var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-7",
    d: "M85.59,250.42C-5.2,302.84-5.2,387.84,85.6,440.26s238,52.42,328.8,0,90.8-137.41,0-189.84S176.39,198,85.59,250.42Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-7",
    cx: 402.21,
    cy: 410.22,
    rx: 35.19,
    ry: 20.32,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 464.99 21.65 345.38 228.82 225.93 436 345.38 228.83 464.99",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-7",
    d: "M82.47,47.31l-6.64,3.84a8.65,8.65,0,0,0,0-.88V48.35c0-3.43-2.4-4.82-5.37-3.11a10.53,10.53,0,0,0-3.21,3.08c-.48-4.31-3.86-5.91-8-3.54-4.44,2.56-8,8.8-8,13.93v2.88A7.52,7.52,0,0,0,52,64.93l-5.52,3.19a6.58,6.58,0,0,0-3,5.16c0,1.9,1.34,2.67,3,1.72l36-20.8a6.58,6.58,0,0,0,3-5.16C85.46,47.13,84.12,46.36,82.47,47.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-7",
    d: "M112,62.43l-5,2.9a5,5,0,0,0,.05-.66V63.21c0-2.58-1.82-3.63-4.06-2.34a7.75,7.75,0,0,0-2.42,2.33c-.37-3.26-2.92-4.47-6-2.68A13.43,13.43,0,0,0,88.44,71v2.18A5.73,5.73,0,0,0,89,75.73l-4.17,2.4A5,5,0,0,0,82.54,82c0,1.43,1,2,2.25,1.3L112,67.63a5,5,0,0,0,2.25-3.9C114.23,62.3,113.22,61.72,112,62.43Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tree--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Bush--inject-7",
    d: "M44.1,337.48c5.7.91,10.81-.67,11.68-6.83a54.69,54.69,0,0,0,0-15.28c-.25-1.83-.9-4-2.69-4.47A3.41,3.41,0,0,0,49.42,313a10,10,0,0,0-.63,4.48c-.9-2-2.24-4.3-4.43-4.35-2,0-3.56,2.08-3.63,4.11s.91,3.92,1.86,5.71c-1.54-.21-3.28-.32-4.45.7-1.39,1.21-1.24,3.55-.16,5.05a11.38,11.38,0,0,0,4.47,3.2,2,2,0,0,0-2.71,1.33,3.06,3.06,0,0,0,1.16,3.06A6.65,6.65,0,0,0,44.1,337.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tree--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.16,275.16a5.74,5.74,0,0,0-3.14.57,31.79,31.79,0,0,0-5.13,3.63,10.41,10.41,0,0,1-5.69,2.46c-2.1.07-4.36-1.24-4.74-3.3a3.18,3.18,0,0,0-.27-1.06A1.55,1.55,0,0,0,42.4,277a9.36,9.36,0,0,0-1.73,1c-2.12,1.25-4.78,1-7.22.61-2-.29-4.59-1.19-4.58-3.24,0-1.34,1.17-2.32,2.09-3.29s1.67-2.53.83-3.57a2.49,2.49,0,0,0-1.18-.72c-2.54-.83-5.64.27-7.78-1.32a4.46,4.46,0,0,1-1.13-5.36,6.81,6.81,0,0,1,4.57-3.49c1.71-.43,3.87-.63,4.5-2.27.56-1.44-.56-3-1.82-3.87s-2.78-1.51-3.66-2.77a4.38,4.38,0,0,1-.12-4.54A5.55,5.55,0,0,1,29,241.54a8.49,8.49,0,0,0,2.32-.5,1.55,1.55,0,0,0,.86-2c-.23-.42-.71-.63-1-1a1.86,1.86,0,0,1,.68-2.42,9.59,9.59,0,0,1,2.6-1c1.84-.61,3.62-2.4,3.08-4.26s-3.21-2.56-4-4.42c-.69-1.65.41-3.57,1.88-4.58s3.27-1.41,4.89-2.17,3.18-2.12,3.31-3.9-1.24-3.36-2.35-4.81-2.07-3.48-1.09-5,3-1.58,4.69-2.11a7.67,7.67,0,0,0,4.63-4.17c.44-1,.66-2.16,1.19-3.14,1.67-3.08,5.85-4.42,9.09-4a3.65,3.65,0,0,1,3.08,2.09A4.76,4.76,0,0,1,64,196.24c.25,1.48-.54,3.37.86,4.5,2.13,1.72,5.39-.59,5.27,3.26a16.21,16.21,0,0,1-.72,4.79c-.58,1.62-1.74,2.32-.77,4.13,1.25,2.35,2.07,2.33,4.57,2.33,1.81,0,3.33-.1,4.66,1.27,2.33,2.42.94,4.61-1.13,6.47-2.36,2.12-1.11,3-.8,5.79.14,1.32-.16,1.73,1,2.61,2.23,1.65,3.48,1.09,2.85,4.34-.57,3,.31,2,2.88,3.06,2.28,1,3.78,3.43,5.63,5,1.18,1,3,1.75,3.1,3.47.22,3.31-3.89,2.58-5.85,3.37-3.19,1.29-2.24,5.48.25,7,2.64,1.66,6.49,2.27,6.7,6.06.17,2.9-1.48,3.54-3.74,4.52-1.79.77-1.57,1-1.56,3.15,0,4.33-1.46,5.55-5.73,4.85-1.17-.2-2.95-.69-4.11-.34-1.64.49-1.09.89-1.13,2.26-.12,3.49-4.19,2.51-5.91,1C68.35,277.43,65.86,275.42,63.16,275.16Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.16,275.16a5.74,5.74,0,0,0-3.14.57,31.79,31.79,0,0,0-5.13,3.63,10.41,10.41,0,0,1-5.69,2.46c-2.1.07-4.36-1.24-4.74-3.3a3.18,3.18,0,0,0-.27-1.06A1.55,1.55,0,0,0,42.4,277a9.36,9.36,0,0,0-1.73,1c-2.12,1.25-4.78,1-7.22.61-2-.29-4.59-1.19-4.58-3.24,0-1.34,1.17-2.32,2.09-3.29s1.67-2.53.83-3.57a2.49,2.49,0,0,0-1.18-.72c-2.54-.83-5.64.27-7.78-1.32a4.46,4.46,0,0,1-1.13-5.36,6.81,6.81,0,0,1,4.57-3.49c1.71-.43,3.87-.63,4.5-2.27.56-1.44-.56-3-1.82-3.87s-2.78-1.51-3.66-2.77a4.38,4.38,0,0,1-.12-4.54A5.55,5.55,0,0,1,29,241.54a8.49,8.49,0,0,0,2.32-.5,1.55,1.55,0,0,0,.86-2c-.23-.42-.71-.63-1-1a1.86,1.86,0,0,1,.68-2.42,9.59,9.59,0,0,1,2.6-1c1.84-.61,3.62-2.4,3.08-4.26s-3.21-2.56-4-4.42c-.69-1.65.41-3.57,1.88-4.58s3.27-1.41,4.89-2.17,3.18-2.12,3.31-3.9-1.24-3.36-2.35-4.81-2.07-3.48-1.09-5,3-1.58,4.69-2.11a7.67,7.67,0,0,0,4.63-4.17c.44-1,.66-2.16,1.19-3.14,1.67-3.08,5.85-4.42,9.09-4a3.65,3.65,0,0,1,3.08,2.09A4.76,4.76,0,0,1,64,196.24c.25,1.48-.54,3.37.86,4.5,2.13,1.72,5.39-.59,5.27,3.26a16.21,16.21,0,0,1-.72,4.79c-.58,1.62-1.74,2.32-.77,4.13,1.25,2.35,2.07,2.33,4.57,2.33,1.81,0,3.33-.1,4.66,1.27,2.33,2.42.94,4.61-1.13,6.47-2.36,2.12-1.11,3-.8,5.79.14,1.32-.16,1.73,1,2.61,2.23,1.65,3.48,1.09,2.85,4.34-.57,3,.31,2,2.88,3.06,2.28,1,3.78,3.43,5.63,5,1.18,1,3,1.75,3.1,3.47.22,3.31-3.89,2.58-5.85,3.37-3.19,1.29-2.24,5.48.25,7,2.64,1.66,6.49,2.27,6.7,6.06.17,2.9-1.48,3.54-3.74,4.52-1.79.77-1.57,1-1.56,3.15,0,4.33-1.46,5.55-5.73,4.85-1.17-.2-2.95-.69-4.11-.34-1.64.49-1.09.89-1.13,2.26-.12,3.49-4.19,2.51-5.91,1C68.35,277.43,65.86,275.42,63.16,275.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2,281.82a10.41,10.41,0,0,0,5.69-2.46A31.79,31.79,0,0,1,60,275.73a5.75,5.75,0,0,1,3.14-.57c2.7.26,5.19,2.27,7.18,4,1.72,1.5,5.79,2.48,5.91-1,0-1.37-.51-1.77,1.13-2.26,1.16-.35,2.94.14,4.11.34,4.27.7,5.73-.52,5.73-4.85,0-2.15-.23-2.38,1.56-3.15,2.26-1,3.91-1.62,3.74-4.52-.21-3.79-4.06-4.4-6.7-6.06-2.49-1.57-3.44-5.76-.25-7,2-.79,6.07-.06,5.85-3.37-.11-1.72-1.92-2.49-3.1-3.47-1.85-1.53-3.35-4-5.63-5-2.57-1.11-3.45-.09-2.88-3.06.63-3.25-.62-2.69-2.85-4.34-1.19-.88-.89-1.29-1-2.61-.31-2.74-1.56-3.67.8-5.79,2.07-1.86,3.46-4.05,1.13-6.47-1.33-1.37-2.85-1.28-4.66-1.27-2.5,0-3.32,0-4.57-2.33-1-1.81.19-2.51.77-4.13a16.21,16.21,0,0,0,.72-4.79c.12-3.85-3.14-1.54-5.27-3.26-1.4-1.13-.61-3-.86-4.5a2.6,2.6,0,0,0-.1-.44,10.8,10.8,0,0,0-1.21,3.63,4.76,4.76,0,0,0,1.94,4.64,7.6,7.6,0,0,1,1.44.83,2.91,2.91,0,0,1,.32,3.3c-.49,1.08-1.29,2-1.71,3.11a5.23,5.23,0,0,0,2.06,6.15c2,1.25,5.26,1.52,5.61,3.87.5,3.36-6,4.72-5.27,8,.31,1.42,1.85,2.13,2.92,3.12a6.91,6.91,0,0,1,1.78,6.38,11.8,11.8,0,0,1-3.49,5.87c-1.21,1.18-2.72,2.8-1.91,4.29s3.11,1.17,4.32,2.32c1,1,.93,2.68.45,4s-1.24,2.63-1.29,4.06c-.07,1.7.91,3.25,1.83,4.7s1.85,3,1.67,4.74c-.44,4.19-5.32,3-7.5,1.39A7.39,7.39,0,0,0,56,271.69c-.84,1.09-1.35,2.4-2.18,3.49a3.69,3.69,0,0,1-3.52,1.69,3.11,3.11,0,0,1-2.17-2.59c-.28-1.25.05-2.8-1.43-3.38s-3.15,0-4.52.71a12.37,12.37,0,0,1-2,1,10.39,10.39,0,0,1-2.47.37,4,4,0,0,1-1.5-.17,1.84,1.84,0,0,1-1.1-1,6.72,6.72,0,0,1-.15-1.86c-.16-1.54-1.35-1.85-2.55-2.4a9.63,9.63,0,0,0-4.51-.88,22,22,0,0,0-3.45.54,17,17,0,0,0,3.46.23h.52l.54,0,.14,0,.66.09.17,0a5.33,5.33,0,0,1,.66.17,3,3,0,0,1,.64.28,1.77,1.77,0,0,1,.54.44,1.88,1.88,0,0,1,.24,1.81A4.64,4.64,0,0,1,31,272.08c-.92,1-2.09,1.95-2.09,3.29a2.21,2.21,0,0,0,.65,1.6,3.07,3.07,0,0,0,.26.25,4.25,4.25,0,0,0,1,.61,9.33,9.33,0,0,0,2.71.78,21.17,21.17,0,0,0,3.73.3c.31,0,.61,0,.92-.07a6.77,6.77,0,0,0,2.57-.84c.29-.17.56-.37.84-.55a4.13,4.13,0,0,1,.89-.45,2.1,2.1,0,0,1,.5-.09,1.54,1.54,0,0,1,1,.21,1.1,1.1,0,0,1,.34.34,1.12,1.12,0,0,1,.11.25,3.13,3.13,0,0,1,.12.53,2.36,2.36,0,0,0,0,.28C44.84,280.58,47.1,281.89,49.2,281.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.82,239.5,58.17,262.6V252L57,206.7,55.27,252v7.15L42.46,236.73l12.81,27.48v71.18a.73.73,0,0,0,.42.6,2.27,2.27,0,0,0,2.06,0,.73.73,0,0,0,.42-.6v-66.9Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bush--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-7",
    d: "M54,339.91l13.62-7.86a10.88,10.88,0,0,0,3-2.79,7.83,7.83,0,0,0,1.66-3.53,1.82,1.82,0,0,0-.14-1.34c-.5-.72-1.66-.47-2.31.12a24.34,24.34,0,0,0-1.85,1.83,20.26,20.26,0,0,0,.26-4.73,2.12,2.12,0,0,0-.57-1.57,1.76,1.76,0,0,0-1.91,0c-1.78,1-2.54,3.08-3.15,5a16.47,16.47,0,0,0-.18-6c-.48-2.14-2.94-3-3.78-.93a12.06,12.06,0,0,0-.72,3.42,14,14,0,0,0,.31,4.53,14.17,14.17,0,0,0-3.63-5,2.2,2.2,0,0,0-2.1-.73c-.86.33-1,1.47-.91,2.39a12.85,12.85,0,0,0,1.85,5.48,11.48,11.48,0,0,0-4.61-1.79,1.38,1.38,0,0,0-1.44.47,1.84,1.84,0,0,0,.31,1.89,11.43,11.43,0,0,0,3.67,3.4,12,12,0,0,0-4.46-.46,1.51,1.51,0,0,0-1.2.5c-.39.57.07,1.33.56,1.81a13.43,13.43,0,0,0,3.19,1.89,4.68,4.68,0,0,0-2,.34,1.55,1.55,0,0,0-.93,1.61A2,2,0,0,0,48,339.14C50.61,340,51.35,340.34,54,339.91Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--bush--inject-7",
    d: "M54,339.91l13.62-7.86a10.88,10.88,0,0,0,3-2.79,7.83,7.83,0,0,0,1.66-3.53,1.82,1.82,0,0,0-.14-1.34c-.5-.72-1.66-.47-2.31.12a24.34,24.34,0,0,0-1.85,1.83,20.26,20.26,0,0,0,.26-4.73,2.12,2.12,0,0,0-.57-1.57,1.76,1.76,0,0,0-1.91,0c-1.78,1-2.54,3.08-3.15,5a16.47,16.47,0,0,0-.18-6c-.48-2.14-2.94-3-3.78-.93a12.06,12.06,0,0,0-.72,3.42,14,14,0,0,0,.31,4.53,14.17,14.17,0,0,0-3.63-5,2.2,2.2,0,0,0-2.1-.73c-.86.33-1,1.47-.91,2.39a12.85,12.85,0,0,0,1.85,5.48,11.48,11.48,0,0,0-4.61-1.79,1.38,1.38,0,0,0-1.44.47,1.84,1.84,0,0,0,.31,1.89,11.43,11.43,0,0,0,3.67,3.4,12,12,0,0,0-4.46-.46,1.51,1.51,0,0,0-1.2.5c-.39.57.07,1.33.56,1.81a13.43,13.43,0,0,0,3.19,1.89,4.68,4.68,0,0,0-2,.34,1.55,1.55,0,0,0-.93,1.61A2,2,0,0,0,48,339.14C50.61,340,51.35,340.34,54,339.91Z",
    style: {
      opacity: 0.25
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Walls--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 447.63 31.78 333.86 228.82 220.25 425.87 333.86 228.83 447.63",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 447.63 31.78 333.86 228.82 220.25 425.87 333.86 228.83 447.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.78 333.86 31.78 343.3 228.83 457.07 228.83 447.63 31.78 333.86",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.78 333.86 31.78 343.3 228.83 457.07 228.83 447.63 31.78 333.86",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.83 457.07 425.87 343.3 425.87 333.86 228.83 447.63 228.83 457.07",
    style: {
      fill: "#22AEE9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--walls--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 245.88 228.87 92.83 377.32 178.54 377.32 331.59 228.87 245.88",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 245.88 228.87 92.83 377.32 178.54 377.32 331.59 228.87 245.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 245.88 228.87 92.83 80.42 178.54 80.42 331.59 228.87 245.88",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 245.88 228.87 92.83 80.42 178.54 80.42 331.59 228.87 245.88",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 245.88 228.87 92.83 80.42 178.54 80.42 331.59 228.87 245.88"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "228.89 417.31 377.32 331.59 228.87 245.88 80.42 331.59 228.89 417.31",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.89 417.31 377.32 331.59 228.87 245.88 80.42 331.59 228.89 417.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "228.87 423.42 228.89 417.31 377.32 331.59 377.32 178.54 382.63 181.6 381.99 335.02 228.87 423.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.9 423.42 228.89 417.31 80.45 331.59 80.45 178.54 75.15 175.48 75.79 335.02 228.9 423.42",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.32 331.59 377.32 323.1 228.87 237.39 228.87 245.88 377.32 331.59",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.42 331.59 80.42 323.1 228.87 237.39 228.87 245.88 80.42 331.59",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "105.55 243.37 107.45 244.46 161.67 213.16 159.78 212.06 105.55 243.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.78 212.06 107.45 242.28 107.45 196.95 159.78 166.73 159.78 212.06",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "159.78 212.06 107.45 242.28 107.45 196.95 159.78 166.73 159.78 212.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.72 180.11 134.72 227.63 136.61 226.53 136.61 179.02 134.72 180.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.78 179.56 134.72 180.11 134.72 227.63 133.78 227.08 133.78 179.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.72 180.11 136.61 179.02 135.67 178.47 133.78 179.56 134.72 180.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.56,162.36l-58,33.49v51.89l58-33.49Zm-1.89,50.8-54.22,31.3V197l54.22-31.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.67 213.16 159.78 212.06 159.78 166.73 161.67 165.64 161.67 213.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.56 162.36 161.67 161.27 103.66 194.76 105.55 195.85 163.56 162.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.66 194.76 105.55 195.85 105.55 247.74 103.66 246.65 103.66 194.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.72 181.2 136.61 180.11 136.61 181.2 134.72 182.29 134.72 181.2",
    style: {
      fill: "#263238"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.72 182.29 133.78 181.74 134.72 181.2 134.72 182.29"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lamp--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M207,261.65c-5.05,2.92-5.05,7.65,0,10.57s13.25,2.92,18.31,0,5-7.65,0-10.57S212.08,258.73,207,261.65Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--lamp--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.33,262.26c-3.78,2.19-3.78,5.73,0,7.91a15.15,15.15,0,0,0,13.69,0c3.78-2.18,3.78-5.72,0-7.91A15.15,15.15,0,0,0,209.33,262.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.86,266.22h0c0-1.43-.94-2.86-2.83-4a15.15,15.15,0,0,0-13.69,0c-1.89,1.1-2.83,2.53-2.83,4h0v1.34h0c0,1.41,1,2.82,2.84,3.89a15.08,15.08,0,0,0,13.69,0c1.87-1.07,2.82-2.48,2.84-3.89h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.33,262.26c-3.78,2.19-3.78,5.73,0,7.91a15.15,15.15,0,0,0,13.69,0c3.78-2.18,3.78-5.72,0-7.91A15.15,15.15,0,0,0,209.33,262.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.22,202.75h-2.09v62.84h0a.5.5,0,0,0,.3.48,1.65,1.65,0,0,0,1.47,0,.5.5,0,0,0,.3-.48h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.78,200.76h0l-3.35-16H205.92l-3.35,16h0c-.91,2.56.34,5.32,3.78,7.3,5.43,3.13,14.22,3.13,19.65,0C229.44,206.08,230.69,203.32,229.78,200.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,189.54a16.16,16.16,0,0,0,14.59,0c4-2.33,4-6.1,0-8.42a16.1,16.1,0,0,0-14.59,0C204.86,183.44,204.86,187.21,208.88,189.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,189.82a12.77,12.77,0,0,1-6.31-1.5c-1.48-.85-2.29-1.91-2.29-3s.81-2.15,2.29-3a14.13,14.13,0,0,1,12.63,0c1.48.85,2.29,1.92,2.29,3s-.81,2.14-2.29,3A12.79,12.79,0,0,1,216.17,189.82Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "364.72 256.37 363.87 256.88 346.45 246.82 347.3 246.31 364.72 256.37",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "364.72 256.37 363.87 256.88 346.45 246.82 347.3 246.31 364.72 256.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "347.3 246.31 363.87 255.88 363.87 238.52 347.3 228.96 347.3 246.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,247.74l20.63,11.91v-22l-20.63-11.91Zm1.6-19.28,17.42,10.06v18.36l-17.42-10.06Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.45 246.82 347.3 246.31 347.3 228.96 346.45 228.46 346.45 246.82",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.45 246.82 347.3 246.31 347.3 228.96 346.45 228.46 346.45 246.82",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.85 225.69 345.71 225.19 366.34 237.1 365.48 237.6 344.85 225.69",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.85 225.69 345.71 225.19 366.34 237.1 365.48 237.6 344.85 225.69",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "366.34 237.1 365.48 237.6 365.48 259.65 366.34 259.16 366.34 237.1",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.34 237.1 365.48 237.6 365.48 259.65 366.34 259.16 366.34 237.1",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-7",
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "347.94 245.79 363.23 254.62 363.23 250.2 359.4 241.38 357.02 243.59 357.88 247.28 352.61 236 347.94 241.38 347.94 245.79",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17,237.12a2.51,2.51,0,0,1,1.13,2c0,.72-.51,1-1.13.65a2.5,2.5,0,0,1-1.13-2C356,237.05,356.55,236.76,357.17,237.12Z",
    style: {
      fill: "#22AEE9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "258.69 195.16 257.84 195.66 240.42 185.6 241.27 185.09 258.69 195.16",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "258.69 195.16 257.84 195.66 240.42 185.6 241.27 185.09 258.69 195.16",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "241.27 185.09 257.84 194.66 257.84 177.31 241.27 167.74 241.27 185.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.82,186.53l20.62,11.91V176.38l-20.62-11.91Zm1.6-19.28,17.42,10.06v18.35L240.42,185.6Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.42 185.6 241.27 185.09 241.27 167.74 240.42 167.25 240.42 185.6",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.42 185.6 241.27 185.09 241.27 167.74 240.42 167.25 240.42 185.6",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.82 164.47 239.68 163.98 260.31 175.89 259.44 176.38 238.82 164.47",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "238.82 164.47 239.68 163.98 260.31 175.89 259.44 176.38 238.82 164.47",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "260.31 175.89 259.44 176.38 259.44 198.44 260.31 197.94 260.31 175.89",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.31 175.89 259.44 176.38 259.44 198.44 260.31 197.94 260.31 175.89",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-7",
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "241.91 184.58 257.19 193.4 257.19 188.99 253.37 180.16 250.99 182.37 251.85 186.07 246.57 174.78 241.91 180.16 241.91 184.58",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,175.91a2.5,2.5,0,0,1,1.13,2c0,.72-.51,1-1.13.66a2.5,2.5,0,0,1-1.13-2C250,175.84,250.51,175.54,251.14,175.91Z",
    style: {
      fill: "#22AEE9"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Television--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tv-stand--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M360,329.59l-34.35,19.83a1.84,1.84,0,0,1-1.65,0l-93.48-54c-.46-.27-.46-.69,0-.95l34.35-19.84a1.82,1.82,0,0,1,1.64,0l93.49,54C360.42,328.9,360.42,329.32,360,329.59Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tv-stand--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.18,295.76l87.24,50.37a3,3,0,0,0,2.74,0l23-13.26a3,3,0,0,0,1.37-2.37V289.13a3,3,0,0,0-1.37-2.37l-87.24-50.37a3,3,0,0,0-2.74,0l-23,13.26a3,3,0,0,0-1.37,2.37v41.37A3,3,0,0,0,236.18,295.76Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.18,295.76l87.24,50.37a3,3,0,0,0,2.74,0l23-13.26a3,3,0,0,0,1.37-2.37V289.13a3,3,0,0,0-1.37-2.37l-87.24-50.37a3,3,0,0,0-2.74,0l-23,13.26a3,3,0,0,0-1.37,2.37v41.37A3,3,0,0,0,236.18,295.76Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.84,279.27a1.24,1.24,0,0,1-.42-.73l-25.71,14.85a1.24,1.24,0,0,0,.42.73l85.77,49.52,25.71-14.85Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.84,279.27a1.24,1.24,0,0,1-.42-.73l-25.71,14.85a1.24,1.24,0,0,0,.42.73l85.77,49.52,25.71-14.85Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--V--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M267.92,310.13l20.43-11.8c.23-.13.23-.34,0-.47L264.15,284a.91.91,0,0,0-.82,0L243,295.71c-.23.13-.23.34,0,.47l24.16,13.95A.89.89,0,0,0,267.92,310.13Z",
    style: {
      opacity: 0.2
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.93,308l-.57-.33a.94.94,0,0,1,.48,0C269,307.75,268.93,308,268.93,308Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M269.32,307.68a.68.68,0,0,0-1,0c-.55.51-.58,1-.81,1s-.23-4-.23-4l2.18,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.55,293l0,0,.35-.2,15-8.65,21.84,14.13c.36.21.42.51.14.68l-.51.29-14,8.09-.1-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.45,302.73l1.08-.23v4.35c-.65.28-1.07.54-1.13,1.09Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,306.91l13.88-8a1,1,0,0,0,.43-.75v-4.29l-14,8.17a1.29,1.29,0,0,1-.67.79c-.49.2-.12.39-.12.39v3.65C269,306.8,269,306.91,269,306.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.74,302.58c.14-.08.25-.09.25,0v.14c0,.15.23.14.52,0s.51-.42.51-.57V302c0-.08.19-.25.43-.39l-22.58-12.94-.35.2a.35.35,0,0,0-.09.19v.14c0,.15-.23.4-.51.57s-.51.17-.51,0v-.14c0-.08-.12-.07-.26,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.55,288.87l0,0,.35-.2,15-8.65,21.84,12.61c.36.21.42.51.14.67l-.51.3-14,8.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.4,289.5l22.57,13-.79.61-22.49-13a.77.77,0,0,1,.3-.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.77,296l0,0,0,0-.05-.06,0,0-.06-.13s0-.09,0-.14l0-.18s0-.06,0-.1v-4a3,3,0,0,1,.21-1.13l22.49,13,.09,5.84-22.49-13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.18,303.14h0l-19.33-9.05c-1.06-.5-1.58.55-1.33,1.65a5.15,5.15,0,0,0,1.16,1.93h0l-2.9-1.67h0l0,0,0,0-.05-.06,0,0-.06-.13s0-.09,0-.14l0-.18s0-.06,0-.1v-4a3,3,0,0,1,.21-1.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,304.28h.5a2.23,2.23,0,0,1,.25-1.1.64.64,0,0,0,.41.14,1.34,1.34,0,0,0,.63-.2,2,2,0,0,0,.58-.51l0-.05a.77.77,0,0,0,.15-.43l13.3-7.67.45-.26.57-.34a.29.29,0,0,0,.18-.25V293a.3.3,0,0,1-.18.26h0l-1.52.88-12.86,7.42c-.24.14-.43.31-.43.39v.14a.48.48,0,0,1-.12.24,1.65,1.65,0,0,1-.39.33c-.29.16-.52.17-.52,0v-.14c0-.08-.11-.07-.25,0l-.26.15A2.07,2.07,0,0,0,267,304.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.47,304.28V308c0,.05,0,.11,0,.16v.12h0a1.46,1.46,0,0,1,.76-.94,1.26,1.26,0,0,1,.62-.19.69.69,0,0,1,.45.16l.05,0,.08-.06,12.86-7.42.74-.42.21-.13.62-.36a.28.28,0,0,0,.14-.24v.59a.29.29,0,0,1-.13.23h0l-.23.13-.15.09-.24.14-.16.09L283,300l-.18.11L272.6,306l-3.26,1.88c-.23.13-.42.18-.43.11v-.15c0-.17-.23-.17-.51,0a.68.68,0,0,0-.41.51v.16c0,.08,0,.17-.07.19l-.08,0-.16.1-.2.11a.18.18,0,0,1-.25,0l0,0,0-.06h0l0,0a.69.69,0,0,1-.05-.13.88.88,0,0,1-.05-.15l0-.17a.34.34,0,0,1,0-.1v-.08a1.34,1.34,0,0,1,0-.2v-3.73Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--v--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M295.64,325.82,316.07,314a.25.25,0,0,0,0-.47l-24.21-13.9a.89.89,0,0,0-.81,0L270.67,311.4c-.23.13-.23.34,0,.47l24.16,13.95A.89.89,0,0,0,295.64,325.82Z",
    style: {
      opacity: 0.2
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.65,323.73l-.57-.33a.9.9,0,0,1,.47,0C296.71,323.44,296.65,323.73,296.65,323.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M297,323.37a.68.68,0,0,0-1,0c-.56.5-.58,1-.81,1s-.23-4-.23-4l2.18,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,308.7l0,0,.35-.2,15-8.65L311.42,314c.36.21.42.51.14.67l-.51.3L297,323l-.1-.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.17,318.42l1.08-.23v4.35c-.65.28-1.07.54-1.14,1.09Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.73,322.6l13.88-8a1,1,0,0,0,.44-.75v-4.29l-14,8.17a1.29,1.29,0,0,1-.67.79c-.5.19-.12.39-.12.39v3.65C296.68,322.49,296.73,322.6,296.73,322.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,318.27c.15-.08.26-.09.26,0v.14c0,.15.23.14.51,0s.52-.41.52-.56v-.14c0-.08.19-.25.43-.39l-22.58-12.94-.35.2a.35.35,0,0,0-.09.19v.14c0,.15-.23.4-.51.57s-.51.17-.51,0v-.14c0-.08-.12-.07-.26,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,304.56l0,0,.35-.2,15-8.65,21.84,12.61c.36.21.42.51.14.67l-.51.3-14,8.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.12,305.19l22.57,13-.79.61-22.5-13a.83.83,0,0,1,.31-.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.49,311.68l0,0,0,0-.05-.06,0,0-.06-.13a.54.54,0,0,1,0-.15.85.85,0,0,1,0-.17s0-.06,0-.1v-4a3.21,3.21,0,0,1,.2-1.13l22.5,13,.09,5.84-22.49-13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.9,318.83h0l-19.33-9.05c-1.06-.5-1.58.55-1.33,1.64a5.13,5.13,0,0,0,1.16,1.94h0l-2.9-1.67h0l0,0,0,0-.05-.06,0,0-.06-.13a.54.54,0,0,1,0-.15.85.85,0,0,1,0-.17s0-.06,0-.1v-4a3.21,3.21,0,0,1,.2-1.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.69,320h.5a2.23,2.23,0,0,1,.25-1.1.64.64,0,0,0,.41.14,1.34,1.34,0,0,0,.63-.2,2,2,0,0,0,.58-.51l0-.05a.86.86,0,0,0,.15-.43l13.29-7.67.45-.26.58-.34a.3.3,0,0,0,.18-.26v-.58a.3.3,0,0,1-.18.26h0l-1.52.88-12.86,7.42c-.24.14-.43.31-.43.39v.14a.43.43,0,0,1-.12.23,1.42,1.42,0,0,1-.39.33c-.29.17-.52.18-.52,0v-.13c0-.08-.11-.07-.26,0l-.25.15A2.07,2.07,0,0,0,294.69,320Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.19,320v3.73c0,.05,0,.1,0,.16V324h0a1.46,1.46,0,0,1,.76-.94,1.26,1.26,0,0,1,.62-.19.71.71,0,0,1,.45.16l0,0,.09-.06L310,315.52l.74-.43L311,315l.62-.36a.3.3,0,0,0,.14-.24V315a.32.32,0,0,1-.13.23h0l-.23.13-.14.09-.25.14-.15.09-.11.06-.19.11-10.21,5.9-3.26,1.88c-.23.13-.42.18-.43.11v-.15c0-.17-.23-.17-.52,0a.69.69,0,0,0-.4.51v.16c0,.08,0,.17-.07.19l-.08,0-.16.1-.2.11a.18.18,0,0,1-.25,0l0,0a.21.21,0,0,1,0-.06h0s0,0,0,0a.43.43,0,0,1-.05-.12.88.88,0,0,1-.05-.15l0-.17s0-.07,0-.1v-.08a1.34,1.34,0,0,1,0-.2V320Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.41,305.85l21.37,12.34,16.16-9.33c.24-.14.24-.37,0-.5l-21.15-12.22-14.2,8.2h0l-.35.2a.35.35,0,0,0-.09.19v.14c0,.15-.23.4-.51.57l-.05,0-.47-.27-.22.12,0,0h0l-.16.1A.77.77,0,0,0,272.41,305.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74,309l-.64-.34.58-.14A.44.44,0,0,1,308.74,309Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.74,309l-.64-.34.58-.14A.44.44,0,0,1,308.74,309Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.7,317.53a1.44,1.44,0,0,0,1.31,0l14.68-8.48-22-12.48-.51-.3-14.69,8.27a.4.4,0,0,0,0,.76Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.21,301.72l5.12,2.95,3.32-1.91,3.86,2.22v2.58c0,.33-.38.81-.52.74a3.78,3.78,0,0,0-.74.26,5.75,5.75,0,0,0-1.06.78l-11.77-6.58Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.21,301.72l5.12,2.95,3.32-1.91,3.86,2.22v2.58c0,.33-.38.81-.52.74a3.78,3.78,0,0,0-.74.26,5.75,5.75,0,0,0-1.06.78l-11.77-6.58Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.39,305.29v2.8l.05,0a1.3,1.3,0,0,1,.62-.2.71.71,0,0,1,.42.1v-3.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67,309.05a1,1,0,0,1,.18-.48l.18-.21.07-.06.08-.06.06-.05.15-.1v-2.78l-.72.41h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.51,307.56c0,.33-.38.81-.52.74h0l-.51-.34v-2.12L309,305l.28-.1.24.13Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.35,314v3.18a.89.89,0,0,0,.44-.1l1.61-.93,12.27-7.08v-3.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.88,302v2.41a.94.94,0,0,0,.44.75l19,11,1.61.93a.88.88,0,0,0,.43.1v-2.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.71,292.43l22,12.69v.29c0,.17.23.23.51.06s.52-.36.52-.65l0-.27-22.39-12.93-.09-.06a.25.25,0,0,0,0,.14v.13C286.22,292,286,292.26,285.71,292.43Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.71,292.43l22,12.69v.29c0,.17.23.23.51.06s.52-.36.52-.65l0-.27-22.39-12.93-.09-.06a.25.25,0,0,0,0,.14v.13C286.22,292,286,292.26,285.71,292.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,313.6l14.36-8.29c.18-.1.35-.18.42-.14l-.1-.05-22-12.69-.26-.15a.82.82,0,0,0-.69.1l-14.25,8.23c-.36.21-.36.55,0,.75L291.7,313.6A1.44,1.44,0,0,0,293,313.6Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.26,291.56l.09.06,22.39,12.93a.31.31,0,0,1,.05-.07l.08,0,.16-.09.2-.12a.2.2,0,0,1,.25,0l0,0,.07.09a.5.5,0,0,1,.05.13.58.58,0,0,1,.05.14l0,.17a.41.41,0,0,1,0,.11V305a1.27,1.27,0,0,1,0,.2v-.63a1.35,1.35,0,0,0-.66-1L287.9,291.33a1.33,1.33,0,0,0-1.17-.09l-.27.16h0s-.06,0-.11.07h0A.24.24,0,0,0,286.26,291.56Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,317.53l.88-.51,13.3-7.68a.79.79,0,0,1,.18-.47,2,2,0,0,1,.58-.51,1.34,1.34,0,0,1,.63-.2.64.64,0,0,1,.41.14,2.26,2.26,0,0,0,.25-1.1h.5a2.07,2.07,0,0,1-.51,1.55l-.26.15c-.14.08-.25.09-.25,0v-.14c0-.15-.23-.14-.52,0s-.51.42-.51.57v.14c0,.08-.19.25-.43.39l-12.86,7.42-1.39.8h0a1.43,1.43,0,0,1-.66.15v-.58A1.29,1.29,0,0,0,293,317.53Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,317.53l.88-.51,13.3-7.68a.79.79,0,0,1,.18-.47,2,2,0,0,1,.58-.51,1.34,1.34,0,0,1,.63-.2.64.64,0,0,1,.41.14,2.26,2.26,0,0,0,.25-1.1h.5a2.07,2.07,0,0,1-.51,1.55l-.26.15c-.14.08-.25.09-.25,0v-.14c0-.15-.23-.14-.52,0s-.51.42-.51.57v.14c0,.08-.19.25-.43.39l-12.86,7.42-1.39.8h0a1.43,1.43,0,0,1-.66.15v-.58A1.29,1.29,0,0,0,293,317.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,313.6h0l.88-.52,10.22-5.89,3.26-1.88c.23-.14.42-.19.43-.12h0v.15c0,.16.23.16.51,0a.7.7,0,0,0,.41-.51v-.16a.27.27,0,0,1,.07-.2l.08,0,.16-.09.2-.12a.2.2,0,0,1,.25,0l0,0,0,.06,0,0a.5.5,0,0,1,.05.13.58.58,0,0,1,.05.14l0,.17a.41.41,0,0,1,0,.11V305a1.27,1.27,0,0,1,0,.2v2h-.5v-2c0-.06,0-.11,0-.16v-.14a1.48,1.48,0,0,1-.76,1,1.26,1.26,0,0,1-.62.19.64.64,0,0,1-.45-.17l0,0-.09.05-12.86,7.43-1.39.8h0a1.36,1.36,0,0,1-.65.15v-.59A1.3,1.3,0,0,0,293,313.6Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,313.6h0l.88-.52,10.22-5.89,3.26-1.88c.23-.14.42-.19.43-.12h0v.15c0,.16.23.16.51,0a.7.7,0,0,0,.41-.51v-.16a.27.27,0,0,1,.07-.2l.08,0,.16-.09.2-.12a.2.2,0,0,1,.25,0l0,0,0,.06,0,0a.5.5,0,0,1,.05.13.58.58,0,0,1,.05.14l0,.17a.41.41,0,0,1,0,.11V305a1.27,1.27,0,0,1,0,.2v2h-.5v-2c0-.06,0-.11,0-.16v-.14a1.48,1.48,0,0,1-.76,1,1.26,1.26,0,0,1-.62.19.64.64,0,0,1-.45-.17l0,0-.09.05-12.86,7.43-1.39.8h0a1.36,1.36,0,0,1-.65.15v-.59A1.3,1.3,0,0,0,293,313.6Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.24,301v.59a.45.45,0,0,0,.26.37h0l19.8,11.43,1.39.8h0a1.39,1.39,0,0,0,.65.16v-.59a1.38,1.38,0,0,1-.65-.15l-.88-.51h0l-20.3-11.73A.45.45,0,0,1,270.24,301Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.24,301v.59a.45.45,0,0,0,.26.37h0l19.8,11.43,1.39.8h0a1.39,1.39,0,0,0,.65.16v-.59a1.38,1.38,0,0,1-.65-.15l-.88-.51h0l-20.3-11.73A.45.45,0,0,1,270.24,301Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.24,304.91v.59a.47.47,0,0,0,.26.38h0l19.8,11.43,1.39.8h0a1.38,1.38,0,0,0,.65.15v-.58a1.28,1.28,0,0,1-.65-.16l-.88-.51h0l-20.3-11.72A.45.45,0,0,1,270.24,304.91Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.24,304.91v.59a.47.47,0,0,0,.26.38h0l19.8,11.43,1.39.8h0a1.38,1.38,0,0,0,.65.15v-.58a1.28,1.28,0,0,1-.65-.16l-.88-.51h0l-20.3-11.72A.45.45,0,0,1,270.24,304.91Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "262.42 257.86 236.71 272.7 300.98 309.81 326.69 294.97 262.42 257.86",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.42 257.86 236.71 272.7 300.98 309.81 326.69 294.97 262.42 257.86",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.71 272.7 236.71 275.3 300.76 312.28 300.76 309.69 236.71 272.7",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.71 272.7 236.71 275.3 300.76 312.28 300.76 309.69 236.71 272.7",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M279.64,280.81,267.25,288a2.42,2.42,0,0,1-2.22,0l-23.85-13.77a.68.68,0,0,1,0-1.29l12.39-7.15a2.48,2.48,0,0,1,2.22,0l23.85,13.77A.68.68,0,0,1,279.64,280.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Console--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.09,286.52l11.06-6.38a2.23,2.23,0,0,0,1-1.72v.13a2.17,2.17,0,0,0-1-1.72L255.93,264a2.18,2.18,0,0,0-2,0l-11.05,6.38a2.17,2.17,0,0,0-1,1.72V272a2.21,2.21,0,0,0,1,1.72l22.22,12.83A2.16,2.16,0,0,0,267.09,286.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,269.87l12,7a2.17,2.17,0,0,1,1,1.72v-.13a2.23,2.23,0,0,1-1,1.72l-11.06,6.38a2,2,0,0,1-1,.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,278l-11,6.38a2.16,2.16,0,0,1-2,0l-22.23-12.83a.6.6,0,0,1,0-1.14L253.94,264a2.18,2.18,0,0,1,2,0l22.22,12.83A.6.6,0,0,1,278.15,278Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,275.88v1.05l-11.47,6.63a1.25,1.25,0,0,1-.41.14,1.16,1.16,0,0,1-.73-.14l-22.65-13.08v-1.09l22.23,12.87a2,2,0,0,0,1,.23,2,2,0,0,0,1-.23Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,275.88v1.05l-11.47,6.63a1.25,1.25,0,0,1-.41.14,1.16,1.16,0,0,1-.73-.14l-22.65-13.08v-1.09l22.23,12.87a2,2,0,0,0,1,.23,2,2,0,0,0,1-.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,275.88v1.05l-11.47,6.63a1.25,1.25,0,0,1-.41.14h-.17v-1.22a2,2,0,0,0,1-.23Z",
    style: {
      fill: "#22AEE9",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.1,282.26l11-6.38a2.2,2.2,0,0,0,1-1.72v-2.05a2.2,2.2,0,0,0-1-1.72l-22.22-12.83a2.25,2.25,0,0,0-2,0l-11.05,6.38a2.2,2.2,0,0,0-1,1.72v2a2.13,2.13,0,0,0,1,1.68l22.22,12.87A2.25,2.25,0,0,0,267.1,282.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,263.44l12,6.95a2.2,2.2,0,0,1,1,1.72v2.05a2.2,2.2,0,0,1-1,1.72l-11,6.38a2.1,2.1,0,0,1-1,.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.15,271.54l-11,6.38a2.16,2.16,0,0,1-2,0l-22.23-12.83a.61.61,0,0,1,0-1.15l11.05-6.38a2.25,2.25,0,0,1,2,0l22.22,12.83A.61.61,0,0,1,278.15,271.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.74,266.47a1.35,1.35,0,0,1,0,2.55,5,5,0,0,1-4.44,0,1.35,1.35,0,0,1,0-2.55A4.89,4.89,0,0,1,262.74,266.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.69,267.22a.83.83,0,0,1,.39.67c0,.25-.17.36-.39.24a.89.89,0,0,1-.39-.68C244.3,267.2,244.48,267.09,244.69,267.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.69,268.71a.86.86,0,0,1,.39.68c0,.25-.17.36-.39.23a.86.86,0,0,1-.39-.67C244.3,268.7,244.48,268.59,244.69,268.71Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,291.2a9.22,9.22,0,0,0,4.77.36l2.16-.37a9.29,9.29,0,0,1,4.76.36c.95.48,1.57,1.4,1.38,2.06l-.73,2.53c-.19.65-.26,1.33,1.37,2.05a3.35,3.35,0,0,0,3.26-.13l6.6-4.28c.86-.55.57-1.51-.64-2.12l-9.3-4.76a6.64,6.64,0,0,0-4.52-.32l-8.51,2.94C270.11,290,269.84,290.72,270.8,291.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.86,290.55c.07-.49-.33-1-1.13-1.45l-9.3-4.75a6.64,6.64,0,0,0-4.52-.32L271.4,287c-.74.25-1.15.61-1.17,1s-.16,1.26-.17,1.55.18.5.57.7a9.49,9.49,0,0,0,4.78.36l2.16-.37a9.3,9.3,0,0,1,4.76.35,2.75,2.75,0,0,1,1.31,1.33l-.5,1.73a1.33,1.33,0,0,0,0,1l-.16.55c-.19.65-.25,1.33,1.37,2.05a3.37,3.37,0,0,0,3.27-.13l6.6-4.28a1,1,0,0,0,.48-.68C294.73,291.8,294.82,290.8,294.86,290.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.07,293l0-4.5-2.81-.74-.25,2.38a4.53,4.53,0,0,1,1.29.37,2.75,2.75,0,0,1,1.31,1.33l-.21.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.34,289.51c.85.77.91,1,.68,4.09s-.94,3.16-1.73,2.63-1.32-2-2.29-1.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,288.65a9.22,9.22,0,0,0,4.77.36l2.16-.37a9.18,9.18,0,0,1,4.76.36c.95.48,1.57,1.4,1.38,2.05l-.73,2.53c-.19.66-.26,1.34,1.37,2.06a3.38,3.38,0,0,0,3.26-.13l6.6-4.28c.86-.56.57-1.51-.64-2.13l-9.3-4.75a6.64,6.64,0,0,0-4.52-.32L271.4,287C270.11,287.41,269.84,288.16,270.8,288.65Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,288.65a9.22,9.22,0,0,0,4.77.36l2.16-.37a9.18,9.18,0,0,1,4.76.36c.95.48,1.57,1.4,1.38,2.05l-.73,2.53c-.19.66-.26,1.34,1.37,2.06a3.38,3.38,0,0,0,3.26-.13l6.6-4.28c.86-.56.57-1.51-.64-2.13l-9.3-4.75a6.64,6.64,0,0,0-4.52-.32L271.4,287C270.11,287.41,269.84,288.16,270.8,288.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.47,289.08c0-.08-.06-.16-.18-.23a1.44,1.44,0,0,0-1.06-.05c-.16.07-.25.16-.25.26s0,.3,0,.37.06.17.18.24a1.34,1.34,0,0,0,1.06.05c.15-.06.24-.15.25-.24S291.47,289.15,291.47,289.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.22,290q0-.13-.18-.24a1.43,1.43,0,0,0-1.06,0c-.15.07-.24.16-.25.25s0,.31,0,.38.06.17.19.24a1.32,1.32,0,0,0,1.05.05c.16-.06.24-.15.25-.24S289.22,290.08,289.22,290Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.36,289c0-.08-.06-.17-.19-.24a1.41,1.41,0,0,0-1.05-.05c-.16.07-.24.16-.25.25s0,.31,0,.37.05.18.18.25a1.34,1.34,0,0,0,1.06.05c.16-.07.24-.16.25-.25S289.35,289.07,289.36,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.33,290.11c0-.09-.05-.18-.18-.25a1.43,1.43,0,0,0-1.06-.05c-.15.07-.24.16-.25.25s0,.3,0,.37.05.18.19.25a1.32,1.32,0,0,0,1.05.05c.16-.06.24-.15.25-.24S291.33,290.17,291.33,290.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.23,288.8c-.31.13-.34.36-.07.51a1.44,1.44,0,0,0,1.06.05c.31-.13.34-.36.07-.51A1.44,1.44,0,0,0,290.23,288.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,289.72c-.31.13-.34.36-.06.51a1.36,1.36,0,0,0,1.05,0c.31-.12.34-.35.07-.5A1.43,1.43,0,0,0,288,289.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.12,288.71c-.31.13-.34.36-.07.51a1.39,1.39,0,0,0,1.06,0c.31-.12.34-.35.06-.5A1.41,1.41,0,0,0,288.12,288.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.09,289.81c-.31.13-.34.36-.07.51a1.44,1.44,0,0,0,1.06.05c.31-.13.34-.36.07-.51A1.43,1.43,0,0,0,290.09,289.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283 284.97 282.02 284.42 280.89 284.87 279.9 284.32 278.78 284.78 278.74 285.2 279.31 285.52 278.64 285.79 278.6 286.21 279.59 286.76 280.71 286.3 281.7 286.85 282.82 286.39 282.87 285.98 282.29 285.65 282.96 285.38 283 284.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.02 284.42 280.89 284.87 279.9 284.32 278.78 284.78 279.77 285.33 278.64 285.79 279.63 286.34 280.75 285.88 281.74 286.44 282.87 285.98 281.88 285.43 283 284.97 282.02 284.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.75 285.88 280.71 286.3 279.59 286.76 279.63 286.34 280.75 285.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.88 285.43 282.29 285.65 282.96 285.38 283 284.97 281.88 285.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.87 285.98 282.82 286.39 281.7 286.85 281.74 286.44 282.87 285.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.77 285.33 278.78 284.78 278.73 285.22 279.31 285.52 279.77 285.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.76 330.86 326.47 316.01 326.47 275.89 300.76 290.73 300.76 330.86",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.76 330.86 326.47 316.01 326.47 275.89 300.76 290.73 300.76 330.86",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.08 287.55 299.08 332.08 300.76 333.05 300.76 288.52 299.08 287.55",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.08 287.55 299.08 332.08 300.76 333.05 300.76 288.52 299.08 287.55",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.86,330.19l15.49-8.92a1.17,1.17,0,0,1,1.06,0l12.23,7a.32.32,0,0,1,0,.61l-14.43,8.32a1.14,1.14,0,0,1-1,0l-6.34-3.61a1.14,1.14,0,0,0-1.05,0h0a1.17,1.17,0,0,1-1.06,0l-4.85-2.76A.32.32,0,0,1,303.86,330.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "318.74 299.77 306.56 306.9 306.5 330.25 318.68 323.13 318.74 299.77",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307,307.28l11.79-6.84a4.9,4.9,0,0,0,2.69,1.47l-11.69,6.82A11.21,11.21,0,0,1,307,307.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,308.69a2.5,2.5,0,0,1-2.26,0l-2-1.14a.69.69,0,0,1,0-1.31l11.62-6.75.49.28-11.43,6.68a.42.42,0,0,0,0,.79l1.84,1.05a1.51,1.51,0,0,0,1.36,0l11.42-6.66.56.32Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,308.69a2.5,2.5,0,0,1-2.26,0l-2-1.14a.69.69,0,0,1,0-1.31l11.62-6.75.49.28-11.43,6.68a.42.42,0,0,0,0,.79l1.84,1.05a1.51,1.51,0,0,0,1.36,0l11.42-6.66.56.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.49,301.94l-.07,23.35L310.81,332a2.52,2.52,0,0,1-2.27,0l-2-1.14a.79.79,0,0,1-.47-.65l.06-23.35a.81.81,0,0,0,.47.65l2,1.14a2.5,2.5,0,0,0,2.26,0Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.49,301.94l-.07,23.35L310.81,332a2.52,2.52,0,0,1-2.27,0l-2-1.14a.79.79,0,0,1-.47-.65l.06-23.35a.81.81,0,0,0,.47.65l2,1.14a2.5,2.5,0,0,0,2.26,0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.74,309a2.3,2.3,0,0,1-1.13-.27l-2-1.14a.81.81,0,0,1-.47-.65l-.06,23.35a.79.79,0,0,0,.47.65l2,1.14a2.37,2.37,0,0,0,1.14.27Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.74,309a2.3,2.3,0,0,1-1.13-.27l-2-1.14a.81.81,0,0,1-.47-.65l-.06,23.35a.79.79,0,0,0,.47.65l2,1.14a2.37,2.37,0,0,0,1.14.27Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "322.94 307.4 311.66 313.99 314.75 333.82 326.03 327.23 322.94 307.4",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.94 307.4 311.66 313.99 314.75 333.82 326.03 327.23 322.94 307.4",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,314.3,323,308a5.87,5.87,0,0,0,2.9,1.13l-10.83,6.32A14.65,14.65,0,0,1,312.1,314.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,315.32a2.92,2.92,0,0,1-2.27.11l-2.15-.88c-.67-.28-.75-.78-.17-1.12l10.77-6.25.53.22-10.58,6.18c-.35.21-.31.5.1.67l2,.81a1.73,1.73,0,0,0,1.36-.07l10.59-6.17.6.25Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,315.32a2.92,2.92,0,0,1-2.27.11l-2.15-.88c-.67-.28-.75-.78-.17-1.12l10.77-6.25.53.22-10.58,6.18c-.35.21-.31.5.1.67l2,.81a1.73,1.73,0,0,0,1.36-.07l10.59-6.17.6.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,309.07l3.09,19.82-10.76,6.26a2.94,2.94,0,0,1-2.28.1l-2.14-.88c-.34-.14-.53-.33-.56-.53L311.26,314c0,.2.22.4.55.54l2.15.88a2.88,2.88,0,0,0,2.27-.11Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,309.07l3.09,19.82-10.76,6.26a2.94,2.94,0,0,1-2.28.1l-2.14-.88c-.34-.14-.53-.33-.56-.53L311.26,314c0,.2.22.4.55.54l2.15.88a2.88,2.88,0,0,0,2.27-.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,315.6a2.8,2.8,0,0,1-1.17-.17l-2.15-.88c-.33-.14-.52-.34-.55-.54l3.09,19.83c0,.2.22.39.56.53l2.14.88a2.8,2.8,0,0,0,1.17.18Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,315.6a2.8,2.8,0,0,1-1.17-.17l-2.15-.88c-.33-.14-.52-.34-.55-.54l3.09,19.83c0,.2.22.39.56.53l2.14.88a2.8,2.8,0,0,0,1.17.18Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,344.45l-1.53,1,1.21.69a3,3,0,0,0,2.73,0l12.22-7.05,10.76-6.21a3,3,0,0,0,1.36-2.37V289.13a2.77,2.77,0,0,0-.4-1.35L323.58,303Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.42,301.6l-87.24-50.37c-.76-.44-1.37-.08-1.37.79v41.37a3,3,0,0,0,1.37,2.37l87.24,50.37c.76.44,1.37.09,1.37-.79V304A3,3,0,0,0,323.42,301.6Zm-.52,42-85.77-49.52a1.24,1.24,0,0,1-.42-.73V253.73l85.76,49.52a1.3,1.3,0,0,1,.43.73Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.42,301.6l-87.24-50.37c-.76-.44-1.37-.08-1.37.79v41.37a3,3,0,0,0,1.37,2.37l87.24,50.37c.76.44,1.37.09,1.37-.79V304A3,3,0,0,0,323.42,301.6Zm-.52,42-85.77-49.52a1.24,1.24,0,0,1-.42-.73V253.73l85.76,49.52a1.3,1.3,0,0,1,.43.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.1,287.78l-25.75,14.78a2.77,2.77,0,0,0-.93-1l-87.24-50.37c-.63-.37-1.17-.18-1.33.4a3,3,0,0,1,1.33-2l23-13.26a3,3,0,0,1,2.74,0l87.24,50.37A2.73,2.73,0,0,1,350.1,287.78Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.1,287.78l-25.75,14.78a2.77,2.77,0,0,0-.93-1l-87.24-50.37c-.63-.37-1.17-.18-1.33.4a3,3,0,0,1,1.33-2l23-13.26a3,3,0,0,1,2.74,0l87.24,50.37A2.73,2.73,0,0,1,350.1,287.78Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--TV--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M265.7,242.2l-1.26.73a.83.83,0,0,0,0,1.58L289,258.71a.83.83,0,0,1,0,1.58l-3.69,2.13a.83.83,0,0,0,0,1.58L299,271.88a3,3,0,0,0,2.74,0l3.69-2.13a3,3,0,0,1,2.74,0L332.85,284a3,3,0,0,0,2.74,0l1.26-.72a.84.84,0,0,0,0-1.59l-68.41-39.5A3.07,3.07,0,0,0,265.7,242.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.14,243.21l9.31,5.38a1.79,1.79,0,0,1,.75,1.07l2.31,16.45a1.11,1.11,0,0,1-.5,1.07l-6,3.47a1.4,1.4,0,0,1-1.26,0l-12.82-7.41a1.33,1.33,0,0,1-.63-1,1.34,1.34,0,0,1,.63-1l4.61-2.66a1.57,1.57,0,0,0,.7-1.08l1-13.17a1.52,1.52,0,0,1,.66-1.06A1.33,1.33,0,0,1,295.14,243.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.14,243.21l9.31,5.38a1.79,1.79,0,0,1,.75,1.07l2.31,16.45a1.11,1.11,0,0,1-.5,1.07l-6,3.47a1.4,1.4,0,0,1-1.26,0l-12.82-7.41a1.33,1.33,0,0,1-.63-1,1.34,1.34,0,0,1,.63-1l4.61-2.66a1.57,1.57,0,0,0,.7-1.08l1-13.17a1.52,1.52,0,0,1,.66-1.06A1.33,1.33,0,0,1,295.14,243.21Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,268.3v2.5a1.24,1.24,0,0,1-.62-.15l-12.83-7.41a1.33,1.33,0,0,1-.63-1,1.18,1.18,0,0,1,.25-.67h2.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,243.89l9.31,5.38a1.68,1.68,0,0,1,.74,1.07l2.1,15.22a1.1,1.1,0,0,1-.5,1.07L301,269.29a1.4,1.4,0,0,1-1.26,0l-12.82-7.4a.39.39,0,0,1,0-.73l4.61-2.66a1.57,1.57,0,0,0,.7-1.08l1-13.17A.43.43,0,0,1,294,243.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,243.89a.43.43,0,0,0-.7.36l-.7,9,12.88,7.44L304,250.34a1.68,1.68,0,0,0-.74-1.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.93,261.16l4.61-2.66A1.55,1.55,0,0,0,292,258l14,8.11a1,1,0,0,1-.42.48L301,269.29a1.38,1.38,0,0,1-1.25,0l-12.83-7.4A.39.39,0,0,1,286.93,261.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.56,275.62l.13-.08a1.91,1.91,0,0,0,.87-1.51V225.32a1.94,1.94,0,0,0-.87-1.52l-66.84-38.43a2,2,0,0,0-1.76,0h0a2,2,0,0,0-.88,1.52v48.7a2,2,0,0,0,.88,1.52l66.7,38.51A1.93,1.93,0,0,0,335.56,275.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.51,226.07l2.8-1.61a1.74,1.74,0,0,1,.25.86V274a1.91,1.91,0,0,1-.87,1.51l-.13.08a1.93,1.93,0,0,1-1.75,0l-.3-.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.68,275.11v-48.7a1.94,1.94,0,0,0-.87-1.52l-66.7-38.51c-.48-.28-.88,0-.88.51v48.7a2,2,0,0,0,.88,1.52l66.7,38.51C334.29,275.9,334.68,275.67,334.68,275.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.45,254.22l-3.57-2.06c-.26-.15-.48,0-.48.25a1,1,0,0,0,.48.8l3.57,2.06c.27.16.49,0,.49-.24A1.06,1.06,0,0,0,300.45,254.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,226.11l-63.86-37c-.28-.16-.5,0-.5.29V233a1.1,1.1,0,0,0,.5.86l63.86,36.87c.28.16.5,0,.5-.28V227A1.1,1.1,0,0,0,332.44,226.11Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.44,226.11l-63.86-37c-.28-.16-.5,0-.5.29V233a1.1,1.1,0,0,0,.5.86l63.86,36.87c.28.16.5,0,.5-.28V227A1.1,1.1,0,0,0,332.44,226.11Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speaker--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M324.85,286.06l-7.67,4.43a.46.46,0,0,0,0,.87l7.8,4.5a1.65,1.65,0,0,0,1.5,0l7.66-4.43a.46.46,0,0,0,0-.87l-7.79-4.5A1.65,1.65,0,0,0,324.85,286.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.76,277.55l7,4a1.52,1.52,0,0,1,.69,1.19V291a1.52,1.52,0,0,1-.69,1.19l-5.05,2.92a1.5,1.5,0,0,1-1.37,0l-7-4a1.51,1.51,0,0,1-.68-1.19v-8.21a1.51,1.51,0,0,1,.68-1.18l5.06-2.92A1.5,1.5,0,0,1,324.76,277.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.32,285.29l-7-4c-.38-.22-.68,0-.68.39v8.21a1.51,1.51,0,0,0,.68,1.19l7,4c.38.22.68,0,.68-.4v-8.2A1.51,1.51,0,0,0,325.32,285.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.69,285.29l5.05-2.92c.38-.22.69,0,.69.4V291a1.52,1.52,0,0,1-.69,1.19l-5.05,2.92c-.38.22-.69,0-.69-.4v-8.2A1.52,1.52,0,0,1,326.69,285.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.39,277.55l-5.06,2.92a.42.42,0,0,0,0,.79l7,4a1.5,1.5,0,0,0,1.37,0l5.05-2.92a.42.42,0,0,0,0-.79l-7-4A1.5,1.5,0,0,0,323.39,277.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,291.56a6.38,6.38,0,0,1-2.87-5c0-1.84,1.29-2.58,2.87-1.66a6.33,6.33,0,0,1,2.88,5C324.7,291.73,323.41,292.48,321.82,291.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,291.23a5.73,5.73,0,0,1-2.58-4.49c0-1.65,1.15-2.32,2.58-1.49a5.71,5.71,0,0,1,2.59,4.48C324.41,291.38,323.25,292.05,321.82,291.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,290a3.34,3.34,0,0,1-1.51-2.61c0-1,.68-1.36,1.51-.88a3.34,3.34,0,0,1,1.52,2.62C323.34,290.07,322.66,290.46,321.82,290Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,290a3.34,3.34,0,0,1-1.51-2.61c0-1,.68-1.36,1.51-.88a3.34,3.34,0,0,1,1.52,2.62C323.34,290.07,322.66,290.46,321.82,290Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82,288.76a1,1,0,0,1-.44-.78c0-.29.2-.4.44-.26a1,1,0,0,1,.45.78C322.27,288.78,322.07,288.9,321.82,288.76Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,282a.56.56,0,0,1,.24.42c0,.16-.11.22-.24.14a.51.51,0,0,1-.25-.42C318.15,282,318.26,282,318.4,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,285.92a.54.54,0,0,1,.25.42c0,.16-.11.22-.25.14a.52.52,0,0,1-.24-.42C324.87,285.9,325,285.84,325.11,285.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.4,289.77a.56.56,0,0,1,.24.43c0,.15-.11.22-.24.14a.54.54,0,0,1-.25-.43C318.15,289.76,318.26,289.69,318.4,289.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.11,293.65a.54.54,0,0,1,.25.43c0,.15-.11.22-.25.14a.56.56,0,0,1-.24-.43C324.87,293.64,325,293.57,325.11,293.65Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M261,249.11l-7.66,4.42a.46.46,0,0,0,0,.87l7.79,4.5a1.65,1.65,0,0,0,1.5,0l7.66-4.42a.46.46,0,0,0,0-.87l-7.79-4.5A1.65,1.65,0,0,0,261,249.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.63,240.52l7,4a1.53,1.53,0,0,1,.68,1.18V254a1.52,1.52,0,0,1-.68,1.18l-5.06,2.92a1.5,1.5,0,0,1-1.37,0l-7-4a1.54,1.54,0,0,1-.68-1.19v-8.2a1.54,1.54,0,0,1,.68-1.19l5.06-2.92A1.57,1.57,0,0,1,260.63,240.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.19,248.27l-7-4c-.37-.21-.68,0-.68.4v8.2a1.54,1.54,0,0,0,.68,1.19l7,4c.38.22.68.05.68-.39v-8.21A1.51,1.51,0,0,0,261.19,248.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.56,248.27l5.06-2.92c.37-.22.68,0,.68.39V254a1.52,1.52,0,0,1-.68,1.18l-5.06,2.92c-.38.22-.69.05-.69-.39v-8.21A1.52,1.52,0,0,1,262.56,248.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,240.52l-5.06,2.92a.42.42,0,0,0,0,.79l7,4a1.5,1.5,0,0,0,1.37,0l5.06-2.92a.42.42,0,0,0,0-.79l-7-4A1.57,1.57,0,0,0,259.26,240.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,254.54a6.37,6.37,0,0,1-2.88-5c0-1.83,1.29-2.58,2.88-1.66a6.35,6.35,0,0,1,2.87,5C260.57,254.71,259.29,255.45,257.7,254.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,254.2a5.71,5.71,0,0,1-2.59-4.48c0-1.65,1.16-2.32,2.59-1.5a5.74,5.74,0,0,1,2.59,4.49C260.28,254.36,259.13,255,257.7,254.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,253a3.34,3.34,0,0,1-1.52-2.62c0-1,.68-1.35,1.52-.87a3.34,3.34,0,0,1,1.51,2.62C259.21,253.05,258.53,253.44,257.7,253Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,253a3.34,3.34,0,0,1-1.52-2.62c0-1,.68-1.35,1.52-.87a3.34,3.34,0,0,1,1.51,2.62C259.21,253.05,258.53,253.44,257.7,253Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,251.73a1,1,0,0,1-.45-.78c0-.28.2-.4.45-.26a1,1,0,0,1,.45.78C258.15,251.76,257.94,251.87,257.7,251.73Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.27,245a.56.56,0,0,1,.24.43c0,.15-.11.22-.24.14a.54.54,0,0,1-.25-.42C254,245,254.13,244.94,254.27,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,248.89a.56.56,0,0,1,.24.43c0,.16-.11.22-.24.14a.54.54,0,0,1-.25-.42C260.74,248.88,260.85,248.82,261,248.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.27,252.75a.56.56,0,0,1,.24.42c0,.16-.11.22-.24.14a.54.54,0,0,1-.25-.42C254,252.73,254.13,252.67,254.27,252.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,256.63a.56.56,0,0,1,.24.42c0,.16-.11.22-.24.14a.51.51,0,0,1-.25-.42C260.74,256.61,260.85,256.55,261,256.63Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Thermostat--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--thermostat--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.76,265.16a.32.32,0,0,1,.12-.27l.7-.41a.3.3,0,0,1,.3,0l9.79,5.65a.92.92,0,0,1,.42.73V280a.3.3,0,0,1-.12.28l-.7.41a.33.33,0,0,1-.3,0L355.19,275a1,1,0,0,1-.43-.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,270.57l-9.78-5.65c-.24-.14-.43,0-.43.24v9.11a1,1,0,0,0,.43.74l9.78,5.65c.24.13.43,0,.43-.25V271.3A.91.91,0,0,0,365,270.57Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.4,271.3v9.11a.32.32,0,0,1-.11.27l.68-.4a.29.29,0,0,0,.13-.28v-9.11a.82.82,0,0,0-.13-.41l-.7.4A.89.89,0,0,1,365.4,271.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,268.33h0l1.26-.72a.25.25,0,0,1,.26,0l6.31,3.64a.82.82,0,0,1,.37.65v5.37a.25.25,0,0,1-.11.24c-.06,0-1.2.7-1.27.73h0a.25.25,0,0,1-.26,0l-5.4-3.12-.91-.53a.79.79,0,0,1-.38-.64h0v-5.37h0A.24.24,0,0,1,356,268.33Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356,268.33h0l1.26-.72a.25.25,0,0,1,.26,0l6.31,3.64a.82.82,0,0,1,.37.65v5.37a.25.25,0,0,1-.11.24c-.06,0-1.2.7-1.27.73h0a.25.25,0,0,1-.26,0l-5.4-3.12-.91-.53a.79.79,0,0,1-.38-.64h0v-5.37h0A.24.24,0,0,1,356,268.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.85,278.27h0c.07,0,1.21-.69,1.27-.73a.25.25,0,0,0,.11-.24v-5.37a.75.75,0,0,0-.11-.37l-1.27.73a.75.75,0,0,1,.11.37V278A.26.26,0,0,1,362.85,278.27Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362.85,278.27h0c.07,0,1.21-.69,1.27-.73a.25.25,0,0,0,.11-.24v-5.37a.75.75,0,0,0-.11-.37l-1.27.73a.75.75,0,0,1,.11.37V278A.26.26,0,0,1,362.85,278.27Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.6,272l-6.31-3.65c-.21-.12-.38,0-.38.22V274a.81.81,0,0,0,.38.64l6.31,3.65c.21.12.37,0,.37-.22v-5.37A.78.78,0,0,0,362.6,272Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.58,271.58a1.05,1.05,0,0,1,1.05.11,3.26,3.26,0,0,1,1.48,2.56,1.07,1.07,0,0,1-.43,1l-.38.21a1,1,0,0,1-1-.1,3.26,3.26,0,0,1-1.48-2.56,1,1,0,0,1,.43-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,273.47a2.77,2.77,0,0,1,.13.78,1.07,1.07,0,0,1-.43,1l-.38.21a1,1,0,0,1-1-.1,2.85,2.85,0,0,1-.61-.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.74,274.46a3.26,3.26,0,0,0-1.48-2.56c-.82-.47-1.48-.09-1.48.86a3.26,3.26,0,0,0,1.48,2.56C360.08,275.79,360.74,275.41,360.74,274.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.52,272.33a.75.75,0,0,1,.74.07,2.32,2.32,0,0,1,1,1.81.73.73,0,0,1-.3.68l-.18.11a.75.75,0,0,1-.74-.08,2.3,2.3,0,0,1-1.05-1.81.73.73,0,0,1,.31-.67Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M360.27,273.88a1.93,1.93,0,0,1,0,.33.73.73,0,0,1-.3.68l-.18.11a.75.75,0,0,1-.74-.08,1.56,1.56,0,0,1-.27-.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M360.12,274.32a2.29,2.29,0,0,0-1-1.81c-.58-.34-1.05-.07-1.05.6a2.3,2.3,0,0,0,1.05,1.81C359.66,275.26,360.12,275,360.12,274.32Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.12,274.32a2.29,2.29,0,0,0-1-1.81c-.58-.34-1.05-.07-1.05.6a2.3,2.3,0,0,0,1.05,1.81C359.66,275.26,360.12,275,360.12,274.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M358.38,270.88l.23-.13s0,0,.06,0l.45.76-.23.14a.86.86,0,0,0-.48,0l-.05-.75S358.36,270.89,358.38,270.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.36,271l.05.75a.86.86,0,0,1,.48,0l-.45-.77C358.4,270.86,358.35,270.87,358.36,271Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Carpet--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--carpet--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-7",
    d: "M188.27,318.61c18.69-10.79,53.73-8.06,78.26,6.1l10.13,5.84c24.53,14.17,29.26,34.4,10.56,45.19s-53.74,8.07-78.27-6.09l-10.12-5.85C174.3,349.64,169.57,329.41,188.27,318.61Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--carpet--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.81,334.41c0,8.8,7.73,18.51,20.66,26l9.94,5.74c13.45,7.76,30.53,12.22,46.88,12.22,11.32,0,21-2.16,28.09-6.23,6.73-3.89,10.29-9.12,10.29-15.13,0-8.8-7.73-18.51-20.66-26l-9.94-5.74c-13.45-7.76-30.54-12.22-46.88-12.22-11.32,0-21,2.16-28.09,6.24C183.37,323.17,179.81,328.4,179.81,334.41Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.29,378.35c11.32,0,21-2.16,28.09-6.23,6.73-3.89,10.29-9.12,10.29-15.13,0-8.8-7.72-18.51-20.66-26l-9.94-5.74c-13.45-7.76-30.53-12.21-46.88-12.21-11.32,0-21,2.15-28.09,6.22-6.73,3.89-10.28,9.12-10.28,15.14,0,8.79,7.72,18.5,20.65,26l9.94,5.74c13.45,7.76,30.54,12.22,46.87,12.22Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.81,334.41c0,8.8,7.73,18.51,20.66,26l9.94,5.74c13.45,7.76,30.53,12.22,46.88,12.22,11.32,0,21-2.16,28.09-6.23,6.73-3.89,10.29-9.12,10.29-15.13,0-8.8-7.73-18.51-20.66-26l-9.94-5.74c-13.45-7.76-30.54-12.22-46.88-12.22-11.32,0-21,2.16-28.09,6.24C183.37,323.17,179.81,328.4,179.81,334.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,361.76l-7.68-4.44c-10.1-5.82-16.12-13.43-16.12-20.34,0-4.76,2.8-8.9,8.1-12,5.5-3.18,13.06-4.86,21.87-4.86A74.74,74.74,0,0,1,259,329.65l7.69,4.43c10.09,5.83,16.11,13.43,16.11,20.34,0,4.77-2.8,8.9-8.1,12-5.5,3.18-13.06,4.86-21.87,4.86h0A74.87,74.87,0,0,1,216.47,361.76Zm57.92,4.08c5.1-2.94,7.79-6.89,7.79-11.42,0-6.68-5.9-14.08-15.8-19.79l-7.68-4.44a74.22,74.22,0,0,0-36.06-9.4c-8.69,0-16.15,1.65-21.55,4.77-5.1,2.95-7.79,6.89-7.79,11.42,0,6.68,5.91,14.08,15.8,19.8l7.68,4.43a74.11,74.11,0,0,0,36.06,9.4h0C261.54,370.61,269,369,274.39,365.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,366.08c7.06,0,13.13-1.34,17.54-3.89,4.2-2.42,6.42-5.69,6.42-9.44,0-5.49-4.82-11.56-12.9-16.22L254.8,333a60.14,60.14,0,0,0-29.26-7.63c-7.07,0-13.14,1.34-17.55,3.89-4.2,2.42-6.42,5.69-6.42,9.45,0,5.49,4.83,11.55,12.9,16.21l6.21,3.59a60.24,60.24,0,0,0,29.26,7.62Z",
    style: {
      fill: "#22AEE9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.05,361.24c5.39,0,10-1,13.37-3,3.21-1.85,4.9-4.34,4.9-7.21,0-4.18-3.68-8.81-9.84-12.36L250.75,336a45.84,45.84,0,0,0-22.31-5.82c-5.39,0-10,1-13.38,3-3.2,1.84-4.9,4.34-4.9,7.2,0,4.19,3.68,8.81,9.84,12.36l4.73,2.74a46,46,0,0,0,22.32,5.81Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.53,362l9.94,5.74c24.09,13.9,58.5,16.59,76.86,6S300,343.28,276,329.38L266,323.64c-24.09-13.91-58.5-16.59-76.85-6S175.44,348.12,199.53,362Zm-19.72-27.62c0-6,3.56-11.24,10.29-15.12,7.06-4.08,16.77-6.24,28.09-6.24,16.34,0,33.43,4.46,46.88,12.22L275,331c12.93,7.47,20.66,17.18,20.66,26,0,6-3.56,11.24-10.29,15.13-7.06,4.07-16.77,6.23-28.09,6.23-16.35,0-33.43-4.46-46.88-12.22l-9.94-5.74C187.54,352.92,179.81,343.21,179.81,334.41Z",
    style: {
      fill: "#22AEE9"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sofas--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--love-seat--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "198.28 290.94 200.1 299.96 201.87 300.98 203.62 299.97 205.46 290.94 201.87 288.87 198.28 290.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.87 300.98 201.87 293.01 198.28 290.94 200.1 299.96 201.87 300.98",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.28 290.94 199.46 296.77 201.87 298.16 204.27 296.77 205.46 290.94 201.87 288.87 198.28 290.94",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.9 276.29 174.72 285.31 176.49 286.33 178.24 285.32 180.08 276.29 176.49 274.21 172.9 276.29",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.49 286.33 176.49 278.36 172.9 276.29 174.72 285.31 176.49 286.33",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.9 276.29 174.08 282.11 176.49 283.51 178.89 282.12 180.08 276.29 176.49 274.21 172.9 276.29",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.24 244.47 176.49 240.28 209.12 259.12 201.87 263.31 169.24 244.47",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "169.24 244.47 176.49 240.28 209.12 259.12 201.87 263.31 169.24 244.47",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.87 263.31 201.87 296.8 209.12 292.61 209.12 259.12 201.87 263.31",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,244.47V278l32.63,18.85V263.31Zm29.95,47.69-27.28-15.75v-27.3l27.28,15.74Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,244.47V278l32.63,18.85V263.31Zm29.95,47.69-27.28-15.75v-27.3l27.28,15.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.17 272.22 171.91 276.41 199.19 292.15 199.19 283.78 179.17 272.22",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.17 272.22 171.91 276.41 199.19 292.15 199.19 283.78 179.17 272.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.17 272.22 179.17 253.29 171.91 249.11 171.91 276.41 179.17 272.22",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.17 272.22 179.17 253.29 171.91 249.11 171.91 276.41 179.17 272.22",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,268.67,141.8,283.18a4.3,4.3,0,0,0-1.93,3.35v6.15A4.27,4.27,0,0,0,141.8,296l28.78,16.61a4.24,4.24,0,0,0,3.86,0l25.14-14.51a4.28,4.28,0,0,0,1.93-3.35v-6.14a4.28,4.28,0,0,0-1.93-3.35l-28.76-16.61A4.32,4.32,0,0,0,167,268.67Z",
    style: {
      fill: "#455a64"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.58,285.28l-28.76-16.61a4.32,4.32,0,0,0-3.87,0L141.8,283.18a1.18,1.18,0,0,0,0,2.23L170.58,302a4.3,4.3,0,0,0,3.86,0l25.14-14.52A1.18,1.18,0,0,0,199.58,285.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,292.68v-6.15c0-1.23.87-1.73,1.93-1.12L170.58,302a4.27,4.27,0,0,1,1.93,3.34v6.15c0,1.23-.87,1.73-1.93,1.11L141.8,296A4.27,4.27,0,0,1,139.87,292.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,311.52v-6.15a4.27,4.27,0,0,1,1.93-3.34l25.14-14.52c1.07-.61,1.93-.11,1.93,1.12v6.14a4.28,4.28,0,0,1-1.93,3.35l-25.14,14.51C173.38,313.25,172.51,312.75,172.51,311.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,257.23,141.8,271.74a4.27,4.27,0,0,0-1.93,3.34v6.15a4.3,4.3,0,0,0,1.93,3.35l28.78,16.61a4.3,4.3,0,0,0,3.86,0l25.14-14.52a4.26,4.26,0,0,0,1.93-3.35v-6.14a4.28,4.28,0,0,0-1.93-3.35l-28.76-16.6A4.26,4.26,0,0,0,167,257.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,273.83l-28.76-16.6a4.26,4.26,0,0,0-3.87,0L141.8,271.74a1.18,1.18,0,0,0,0,2.23l28.78,16.61a4.24,4.24,0,0,0,3.86,0l25.14-14.51A1.18,1.18,0,0,0,199.58,273.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.87,281.23v-6.15c0-1.23.87-1.73,1.93-1.11l28.78,16.61a4.3,4.3,0,0,1,1.93,3.35v6.14c0,1.23-.87,1.73-1.93,1.12L141.8,284.58A4.3,4.3,0,0,1,139.87,281.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.51,300.07v-6.14a4.3,4.3,0,0,1,1.93-3.35l25.14-14.51c1.07-.62,1.93-.12,1.93,1.11v6.14a4.26,4.26,0,0,1-1.93,3.35l-25.14,14.52C173.38,301.8,172.51,301.3,172.51,300.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.17,230.57l3.38,2a5.12,5.12,0,0,1,2.23,3.33l3,22.79a3.61,3.61,0,0,1-1.64,3.33L150,276.48a4.26,4.26,0,0,1-3.87,0l-3.39-2a5.13,5.13,0,0,1-2.23-3.33l-3-22.79a3.61,3.61,0,0,1,1.64-3.33l25.14-14.51A4.26,4.26,0,0,1,168.17,230.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,274.54l3.42,1.95c1.07.61,1.8.12,1.64-1.1l-3-22.79a5.15,5.15,0,0,0-2.23-3.33l-3.39-2c-1.06-.62-1.8-.13-1.64,1.09l3,22.81A5.11,5.11,0,0,0,142.75,274.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.16,245.08l25.14-14.51a4.26,4.26,0,0,1,3.87,0l3.38,2a1.18,1.18,0,0,1,0,2.24l-25.14,14.51a4.24,4.24,0,0,1-3.86,0l-3.39-2A1.19,1.19,0,0,1,139.16,245.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.55,234.76l-25.14,14.51a3.6,3.6,0,0,0-1.63,3.33l3,22.79a1.39,1.39,0,0,0,2.23,1.09L175.18,262a3.61,3.61,0,0,0,1.64-3.33l-3-22.79A1.39,1.39,0,0,0,171.55,234.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.97 329.8 132.79 338.82 134.56 339.84 136.31 338.83 138.15 329.8 134.56 327.73 130.97 329.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.56 339.84 134.56 331.87 130.97 329.8 132.79 338.82 134.56 339.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.97 329.8 132.15 335.63 134.56 337.02 136.96 335.63 138.15 329.8 134.56 327.73 130.97 329.8",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.59 315.15 107.41 324.17 109.18 325.19 110.93 324.18 112.77 315.15 109.18 313.07 105.59 315.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.18 325.19 109.18 317.22 105.59 315.15 107.41 324.17 109.18 325.19",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.59 315.15 106.77 320.97 109.18 322.37 111.58 320.98 112.77 315.15 109.18 313.07 105.59 315.15",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,286.4l-25.14,14.51a4.25,4.25,0,0,0-1.94,3.34v6.15a4.29,4.29,0,0,0,1.94,3.35l28.77,16.61a4.27,4.27,0,0,0,3.86,0l25.14-14.51a4.27,4.27,0,0,0,1.94-3.35v-6.14a4.29,4.29,0,0,0-1.94-3.35l-28.76-16.6A4.26,4.26,0,0,0,136.25,286.4Z",
    style: {
      fill: "#455a64"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.88,303l-28.76-16.6a4.26,4.26,0,0,0-3.87,0l-25.14,14.51a1.18,1.18,0,0,0,0,2.23l28.77,16.61a4.24,4.24,0,0,0,3.86,0l25.14-14.51A1.18,1.18,0,0,0,168.88,303Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,310.4v-6.15c0-1.23.87-1.73,1.94-1.11l28.77,16.61a4.28,4.28,0,0,1,1.93,3.35v6.14c0,1.23-.86,1.73-1.93,1.12l-28.77-16.61A4.29,4.29,0,0,1,109.17,310.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,329.24V323.1a4.3,4.3,0,0,1,1.93-3.35l25.14-14.51c1.07-.62,1.94-.12,1.94,1.11v6.14a4.27,4.27,0,0,1-1.94,3.35l-25.14,14.51C142.68,331,141.81,330.47,141.81,329.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,275l-25.14,14.51a4.29,4.29,0,0,0-1.94,3.35V299a4.27,4.27,0,0,0,1.94,3.35l28.77,16.61a4.27,4.27,0,0,0,3.86,0l25.14-14.52a4.25,4.25,0,0,0,1.94-3.34v-6.14a4.26,4.26,0,0,0-1.94-3.35L140.12,275A4.26,4.26,0,0,0,136.25,275Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,291.56,140.12,275a4.26,4.26,0,0,0-3.87,0l-25.14,14.51a1.18,1.18,0,0,0,0,2.23l28.77,16.61a4.24,4.24,0,0,0,3.86,0l25.14-14.51A1.18,1.18,0,0,0,168.88,291.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,299v-6.14c0-1.23.87-1.73,1.94-1.12l28.77,16.61a4.28,4.28,0,0,1,1.93,3.35v6.14c0,1.24-.86,1.74-1.93,1.12L111.11,302.3A4.27,4.27,0,0,1,109.17,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,317.79v-6.14a4.3,4.3,0,0,1,1.93-3.35l25.14-14.51c1.07-.62,1.94-.12,1.94,1.12v6.14a4.25,4.25,0,0,1-1.94,3.34l-25.14,14.52C142.68,319.52,141.81,319,141.81,317.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.47,248.29l3.39,2a5.09,5.09,0,0,1,2.22,3.33l3,22.78a3.59,3.59,0,0,1-1.64,3.33l-25.14,14.52a4.3,4.3,0,0,1-3.86,0l-3.4-2a5.09,5.09,0,0,1-2.22-3.32l-3-22.79a3.58,3.58,0,0,1,1.63-3.33l25.14-14.52A4.32,4.32,0,0,1,137.47,248.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.06,292.26l3.41,2c1.07.61,1.81.11,1.64-1.11l-3-22.79a5.12,5.12,0,0,0-2.23-3.33L108.46,265c-1.06-.62-1.8-.13-1.64,1.1l3,22.81A5.05,5.05,0,0,0,112.06,292.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,262.81l25.14-14.52a4.32,4.32,0,0,1,3.87,0l3.39,2a1.18,1.18,0,0,1,0,2.23L115.72,267a4.26,4.26,0,0,1-3.87,0L108.46,265A1.18,1.18,0,0,1,108.46,262.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.86,252.48,115.72,267a3.61,3.61,0,0,0-1.64,3.33l3,22.79a1.39,1.39,0,0,0,2.23,1.1l25.14-14.52a3.59,3.59,0,0,0,1.64-3.33l-3-22.78A1.38,1.38,0,0,0,140.86,252.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.93 283.33 109.18 279.14 141.81 297.98 134.56 302.17 101.93 283.33",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "101.93 283.33 109.18 279.14 141.81 297.98 134.56 302.17 101.93 283.33",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "134.56 302.17 134.56 335.66 141.81 331.47 141.81 297.98 134.56 302.17",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93,283.33v33.48l32.63,18.85V302.17ZM131.88,331l-27.27-15.75V288l27.27,15.74Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.93,283.33v33.48l32.63,18.85V302.17ZM131.88,331l-27.27-15.75V288l27.27,15.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.86 311.08 104.61 315.27 131.88 331.01 131.88 322.64 111.86 311.08",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.86 311.08 104.61 315.27 131.88 331.01 131.88 322.64 111.86 311.08",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.86 311.08 111.86 292.15 104.61 287.97 104.61 315.27 111.86 311.08",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.86 311.08 111.86 292.15 104.61 287.97 104.61 315.27 111.86 311.08",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--love-seat--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "165.1 362.11 163.28 371.13 161.52 372.15 159.76 371.14 157.93 362.11 161.52 360.04 165.1 362.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.52 372.15 161.52 364.18 165.1 362.11 163.28 371.13 161.52 372.15",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.1 362.11 163.93 367.94 161.52 369.33 159.11 367.94 157.93 362.11 161.52 360.04 165.1 362.11",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.07 345.34 192.25 354.37 190.48 355.39 188.73 354.38 186.9 345.34 190.48 343.27 194.07 345.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.48 355.39 190.48 347.41 194.07 345.34 192.25 354.37 190.48 355.39",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.07 345.34 192.9 351.17 190.48 352.56 188.08 351.18 186.9 345.34 190.48 343.27 194.07 345.34",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.15 315.64 186.89 311.45 154.26 330.29 161.51 334.48 194.15 315.64",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.15 315.64 186.89 311.45 154.26 330.29 161.51 334.48 194.15 315.64",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "161.51 334.48 161.51 367.97 154.26 363.78 154.26 330.29 161.51 334.48",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.51 334.48 161.51 367.97 154.26 363.78 154.26 330.29 161.51 334.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.52,334.48V368l32.63-18.84V315.64Zm2.67,1.54,27.28-15.74v27.3l-27.28,15.75Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.22 343.39 191.47 347.58 164.19 363.33 164.19 354.95 184.22 343.39",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.22 343.39 191.47 347.58 164.19 363.33 164.19 354.95 184.22 343.39",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.22 343.39 184.22 324.46 191.47 320.28 191.47 347.58 184.22 343.39",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.22 343.39 184.22 324.46 191.47 320.28 191.47 347.58 184.22 343.39",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,337.73l25.15,14.51a4.26,4.26,0,0,1,1.93,3.35v6.14a4.28,4.28,0,0,1-1.93,3.35L196.4,381.69a4.32,4.32,0,0,1-3.87,0l-25.14-14.52a4.27,4.27,0,0,1-1.93-3.34v-6.15a4.27,4.27,0,0,1,1.93-3.34l28.77-16.61A4.24,4.24,0,0,1,200,337.73Z",
    style: {
      fill: "#455a64"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.39,354.34l28.77-16.61a4.24,4.24,0,0,1,3.86,0l25.15,14.51a1.18,1.18,0,0,1,0,2.23L196.4,371.08a4.26,4.26,0,0,1-3.87,0l-25.14-14.51A1.18,1.18,0,0,1,167.39,354.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.1,361.73v-6.14c0-1.24-.86-1.74-1.93-1.12L196.4,371.08a4.29,4.29,0,0,0-1.94,3.35v6.14c0,1.23.87,1.73,1.94,1.12l28.77-16.61A4.28,4.28,0,0,0,227.1,361.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.46,380.57v-6.14a4.28,4.28,0,0,0-1.93-3.35l-25.14-14.51c-1.06-.62-1.93-.12-1.93,1.11v6.15a4.27,4.27,0,0,0,1.93,3.34l25.14,14.52C193.6,382.3,194.46,381.8,194.46,380.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,326.28l25.15,14.51a4.28,4.28,0,0,1,1.93,3.35v6.15a4.24,4.24,0,0,1-1.93,3.34L196.4,370.24a4.26,4.26,0,0,1-3.87,0l-25.14-14.51a4.3,4.3,0,0,1-1.93-3.35v-6.14a4.3,4.3,0,0,1,1.93-3.35l28.77-16.61A4.3,4.3,0,0,1,200,326.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.39,342.89l28.77-16.61a4.3,4.3,0,0,1,3.86,0l25.15,14.51a1.18,1.18,0,0,1,0,2.23L196.4,359.64a4.32,4.32,0,0,1-3.87,0l-25.14-14.52A1.18,1.18,0,0,1,167.39,342.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.1,350.29v-6.15c0-1.23-.86-1.73-1.93-1.12L196.4,359.64a4.25,4.25,0,0,0-1.94,3.34v6.15c0,1.23.87,1.73,1.94,1.11l28.77-16.61A4.24,4.24,0,0,0,227.1,350.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.46,369.13V363a4.24,4.24,0,0,0-1.93-3.34l-25.14-14.52c-1.06-.61-1.93-.11-1.93,1.12v6.14a4.3,4.3,0,0,0,1.93,3.35l25.14,14.51C193.6,370.86,194.46,370.36,194.46,369.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15,332.42,171,317.9a4.24,4.24,0,0,0-3.86,0l-3.39,2a3.46,3.46,0,0,0-1.58,3.32l2.93,18.61a5.25,5.25,0,0,0,2.28,3.32l25.14,14.52a4.32,4.32,0,0,0,3.87,0l3.41-1.95a3.48,3.48,0,0,0,1.59-3.31l-3-18.65A5.26,5.26,0,0,0,196.15,332.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,357.69l-3.41,1.95a1.44,1.44,0,0,1-2.29-1.1l-2.93-18.62a3.5,3.5,0,0,1,1.59-3.32l3.38-2a1.43,1.43,0,0,1,2.28,1.08l3,18.65A3.48,3.48,0,0,1,199.81,357.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15,332.42,171,317.9a4.24,4.24,0,0,0-3.86,0l-3.39,2a1.18,1.18,0,0,0,0,2.23L188.9,336.6a4.26,4.26,0,0,0,3.87,0l3.38-2A1.18,1.18,0,0,0,196.15,332.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,322.09,188.9,336.6a5.28,5.28,0,0,1,2.28,3.32l2.93,18.62c.19,1.22-.52,1.7-1.58,1.09l-25.14-14.52a5.25,5.25,0,0,1-2.28-3.32l-2.93-18.61C162,322,162.69,321.47,163.76,322.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.41 400.97 230.59 409.99 228.82 411.01 227.07 410 225.24 400.97 228.83 398.9 232.41 400.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.82 411.01 228.83 403.04 232.41 400.97 230.59 409.99 228.82 411.01",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.41 400.97 231.24 406.8 228.82 408.19 226.42 406.8 225.24 400.97 228.83 398.9 232.41 400.97",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.79 386.32 255.97 395.34 254.2 396.36 252.45 395.35 250.62 386.32 254.2 384.25 257.79 386.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.2 396.36 254.2 388.39 257.79 386.32 255.97 395.34 254.2 396.36",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.79 386.32 256.62 392.14 254.2 393.54 251.8 392.15 250.62 386.32 254.2 384.25 257.79 386.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.72,355.45,255.87,370a4.3,4.3,0,0,1,1.93,3.35v6.15a4.24,4.24,0,0,1-1.93,3.34l-28.78,16.61a4.24,4.24,0,0,1-3.86,0L198.09,384.9a4.28,4.28,0,0,1-1.93-3.35v-6.14a4.28,4.28,0,0,1,1.93-3.35l28.77-16.61A4.3,4.3,0,0,1,230.72,355.45Z",
    style: {
      fill: "#455a64"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.09,372.06l28.77-16.61a4.3,4.3,0,0,1,3.86,0L255.87,370a1.18,1.18,0,0,1,0,2.23l-28.78,16.62a4.3,4.3,0,0,1-3.86,0l-25.14-14.52A1.18,1.18,0,0,1,198.09,372.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,379.46v-6.15c0-1.23-.86-1.73-1.93-1.12l-28.78,16.62a4.27,4.27,0,0,0-1.93,3.34v6.15c0,1.23.87,1.73,1.93,1.11l28.78-16.61A4.24,4.24,0,0,0,257.8,379.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,398.3v-6.15a4.24,4.24,0,0,0-1.93-3.34l-25.14-14.52c-1.07-.61-1.93-.11-1.93,1.12v6.14a4.28,4.28,0,0,0,1.93,3.35l25.14,14.51C224.3,400,225.16,399.53,225.16,398.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.72,344l25.15,14.51a4.27,4.27,0,0,1,1.93,3.34V368a4.28,4.28,0,0,1-1.93,3.35L227.09,388a4.24,4.24,0,0,1-3.86,0l-25.14-14.51a4.26,4.26,0,0,1-1.93-3.35V364a4.28,4.28,0,0,1,1.93-3.35L226.86,344A4.24,4.24,0,0,1,230.72,344Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.09,360.61,226.86,344a4.24,4.24,0,0,1,3.86,0l25.15,14.51a1.18,1.18,0,0,1,0,2.23l-28.78,16.61a4.24,4.24,0,0,1-3.86,0l-25.14-14.51A1.18,1.18,0,0,1,198.09,360.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,368v-6.15c0-1.23-.86-1.73-1.93-1.11l-28.78,16.61a4.29,4.29,0,0,0-1.93,3.35v6.14c0,1.23.87,1.73,1.93,1.11l28.78-16.6A4.28,4.28,0,0,0,257.8,368Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,386.85v-6.14a4.26,4.26,0,0,0-1.93-3.35l-25.14-14.51c-1.07-.62-1.93-.12-1.93,1.11v6.14a4.26,4.26,0,0,0,1.93,3.35L223.23,388C224.3,388.58,225.16,388.08,225.16,386.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.85,350.13l-25.14-14.52a4.32,4.32,0,0,0-3.87,0l-3.38,2a3.5,3.5,0,0,0-1.59,3.32l2.93,18.62a5.38,5.38,0,0,0,2.28,3.32l25.14,14.51a4.29,4.29,0,0,0,3.87,0l3.42-2a3.47,3.47,0,0,0,1.59-3.31l-3-18.64A5.25,5.25,0,0,0,226.85,350.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.51,375.4l-3.42,2a1.43,1.43,0,0,1-2.28-1.1l-2.93-18.62a3.5,3.5,0,0,1,1.58-3.32l3.39-1.95a1.43,1.43,0,0,1,2.28,1.09l3,18.64A3.47,3.47,0,0,1,230.51,375.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.85,350.13l-25.14-14.52a4.32,4.32,0,0,0-3.87,0l-3.38,2a1.18,1.18,0,0,0,0,2.23l25.14,14.51a4.24,4.24,0,0,0,3.86,0l3.39-1.95A1.18,1.18,0,0,0,226.85,350.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.46,339.8l25.14,14.51a5.34,5.34,0,0,1,2.28,3.32l2.93,18.62c.19,1.22-.52,1.71-1.59,1.09l-25.14-14.51a5.38,5.38,0,0,1-2.28-3.32l-2.93-18.62C192.68,339.67,193.39,339.18,194.46,339.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.57 402.64 161.52 367.97 161.51 338.66 221.57 373.34 221.57 402.64",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.57 402.64 161.52 367.97 161.51 338.66 221.57 373.34 221.57 402.64",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.51 338.66 164.19 337.11 225.83 372.7 223.15 374.25 161.51 338.66",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "161.51 338.66 164.19 337.11 225.83 372.7 223.15 374.25",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.45 354.5 254.2 350.31 221.57 369.15 228.82 373.34 261.45 354.5",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.45 354.5 254.2 350.31 221.57 369.15 228.82 373.34 261.45 354.5",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "228.82 373.34 228.82 406.83 221.57 402.64 221.57 369.15 228.82 373.34",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.82 373.34 228.82 406.83 221.57 402.64 221.57 369.15 228.82 373.34",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83,373.34v33.49L261.46,388V354.5Zm2.67,1.54,27.28-15.74v27.3L231.5,402.19Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.53 382.25 258.78 386.44 231.5 402.19 231.5 393.81 251.53 382.25",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.53 382.25 258.78 386.44 231.5 402.19 231.5 393.81 251.53 382.25",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.53 382.25 251.53 363.32 258.78 359.14 258.78 386.44 251.53 382.25",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.53 382.25 251.53 363.32 258.78 359.14 258.78 386.44 251.53 382.25",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Roof--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--roof--inject-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.74 77.53 59.22 178.54 125.57 216.85 205.1 115.84 138.74 77.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.22 178.54 59.22 184.66 125.57 222.97 125.57 216.85 59.22 178.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.1 115.84 205.09 121.96 125.57 222.97 125.57 216.85 205.1 115.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.49 94.29 138.74 77.53 297.8 169.36 396.54 186.12 237.49 94.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.09 121.96 297.8 175.48 297.8 169.36 205.1 115.84 205.09 121.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.8 175.48 396.54 192.24 396.54 186.12 297.8 169.36 297.8 175.48",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--solar-panel--inject-7"
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.33 120.35 123.09 83.84 59.65 164.43 60.45 167.27 123.68 203.78 187.13 123.19 186.33 120.35"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "123.09 83.84 59.65 164.43 122.88 200.94 186.33 120.35 123.09 83.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.66 163.66 123.76 87.32 182.31 121.12 122.21 197.46 63.66 163.66",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.88 200.94 123.68 203.78 187.13 123.19 186.33 120.35 122.88 200.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.09 208.78 125.71 210.99 189.15 130.4 188.53 128.19 125.09 208.78",
    style: {
      fill: "#263238"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.09 208.78 61.85 172.27 62.47 174.48 125.71 210.99 125.09 208.78"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "125.71 210.99 126.68 209.75 123.86 199.7 122.88 200.94 125.71 210.99",
    style: {
      fill: "#263238"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.12 210.07 125.71 210.99 122.88 200.94 121.3 200.03 124.12 210.07"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.79 202.95 113.38 203.87 110.55 193.82 108.97 192.91 111.79 202.95"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "99.46 195.84 101.05 196.75 98.22 186.7 96.64 185.79 99.46 195.84"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.13 188.72 88.72 189.63 85.89 179.58 84.31 178.67 87.13 188.72"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.8 181.6 76.39 182.51 73.56 172.47 71.98 171.55 74.8 181.6"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "62.47 174.48 64.06 175.39 61.23 165.35 59.65 164.43 62.47 174.48"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "136.12 197.76 137.09 196.52 134.27 186.47 133.29 187.72 136.12 197.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.53 184.54 147.51 183.3 144.68 173.25 143.71 174.49 146.53 184.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.94 171.31 157.92 170.07 155.09 160.03 154.12 161.27 156.94 171.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.35 158.09 168.33 156.85 165.51 146.8 164.53 148.04 167.35 158.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.76 144.86 178.74 143.62 175.92 133.57 174.94 134.82 177.76 144.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.18 131.64 189.15 130.4 186.33 120.35 185.35 121.59 188.18 131.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.16,128.8l5.69-7.23-4.77-2.75h0l-4.77-2.76h0l-5.56-3.2-5.9,7.49-5.47,7h0l-6.25,7.93L148.9,138h0l4.78,2.76h0l5.55,3.2,5.69-7.22h0l5.68-7.22h0l.35-.44.21-.27Zm.36-9.27,4,2.3-5.13,6.52-2-1.16-2-1.15,2.56-3.26Zm-11.6,13.29-2-1.16-2-1.15,2.57-3.26,2.56-3.25,2,1.15,2,1.15-2.56,3.26Zm6.83-16,4,2.31-2.57,3.25-2.56,3.26-2-1.15-2-1.15,2.56-3.26ZM162,114l4,2.3-2.57,3.26-2.56,3.26-2-1.15-2-1.16Zm-10.82,13.74,5.13-6.52,2,1.15,2,1.16-2.57,3.25-2.56,3.26-2-1.15Zm-1.7,9.52-4-2.3,5.13-6.51,2,1.15,2,1.15L152,134Zm4.77,2.76-4-2.3,2.57-3.26,2.56-3.26,2,1.15,2,1.15-2.56,3.26Zm9.91-3.76L159,142.79l-4-2.3,2.56-3.26,2.56-3.25,2,1.15Zm5.68-7.22-5.13,6.51-2-1.15-2-1.15,2.57-3.26,2.56-3.26,2,1.15Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.85,109.56l-5.69,7.22h0l-6.25,7.94,4.78,2.75h0l4.77,2.76h0l5.55,3.2,5.69-7.22h0l5.68-7.23h0l6.25-7.93-4.77-2.75h0l-4.77-2.76h0l-5.56-3.2-5.68,7.22Zm-4.91,7.68,5.13-6.52,2,1.15,2,1.15-2.57,3.26-2.56,3.26-2-1.15Zm13.89-1.46L144.27,119l-2.57,3.25-2-1.15-2-1.15,2.57-3.26,2.56-3.25,2,1.15Zm-19.58,8.68,5.13-6.52,2,1.16,2,1.15-2.56,3.26-2.57,3.25Zm8.76,5.06-4-2.31,2.57-3.25,2.56-3.26,2,1.15,2,1.15-2.56,3.26Zm9.91-3.76-5.13,6.51-4-2.3,2.56-3.26,2.56-3.26,2,1.16Zm.55-.71-2-1.15-2-1.15,2.57-3.26,2.56-3.26,4,2.3Zm6.83-16,4,2.3-5.13,6.52-.39-.23-3.6-2.08,4.81-6.11Zm-4.77-2.76,4,2.31-5.13,6.51-2-1.15-2-1.15,2.56-3.26Zm-9.9,3.76,5.13-6.51,4,2.3-2.57,3.26-2.56,3.26-2-1.16Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M112.47,117l4.77,2.76h0l5.55,3.2,5.9-7.49,5.47-7h0l6.25-7.93-4.77-2.75h0L130.87,95h0l-5.56-3.2L119.63,99h0l-5.69,7.22h0l-6.25,7.94,4.78,2.75Zm5.32,2-4-2.31,2.57-3.25,2.56-3.26,2,1.15,2,1.15-2.56,3.26Zm6.83-16,2,1.16,2,1.15-2.56,3.26-2.57,3.25-2-1.15-2-1.15,2.57-3.26Zm-2.05,18.8-4-2.3,2.56-3.26,2.57-3.26,2,1.15,2,1.16ZM133.38,108l-5.13,6.52-2-1.15-2-1.16,2.57-3.25,2.56-3.26,2,1.15Zm5.69-7.22-5.13,6.51-2-1.15L130,105l2.56-3.26,2.57-3.26Zm-8.76-5.06,4,2.3-2.57,3.26-2.56,3.26-2-1.15-2-1.15L127.74,99Zm-9.9,3.76L125.54,93l4,2.3L127,98.54l-2.56,3.25-2-1.15Zm-5.69,7.22,5.13-6.51,2,1.15,2,1.15-2.57,3.26L118.71,109l-2-1.15ZM109,113.94l5.13-6.52,2,1.16,2,1.15L115.59,113,113,116.24Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.56,146.08l-4.78-2.76h0L148,140.57h0l-5.55-3.21-5.69,7.23h0l-5.69,7.22h0l-.34.44-.21.27h0l-5.69,7.22,4.77,2.76h0l4.77,2.75h0l5.56,3.21,5.68-7.23h0l.44-.55.12-.15h0l5.34-6.79ZM152.23,144l4,2.31-5.13,6.51-2-1.15-2-1.15,2.56-3.26Zm-11.6,13.29-2-1.15-2-1.15,2.56-3.26,2.57-3.26,4,2.3-2.57,3.26Zm10.81-13.74-2.56,3.26-2.56,3.26-1-.57-3-1.74,5.12-6.51ZM137.55,145l5.13-6.52,4,2.31-5.13,6.51-2-1.15Zm-5.68,7.22,5.13-6.51,2,1.15,2,1.15-2.57,3.26-2.56,3.25-2-1.15Zm-1.7,9.53-4-2.3,5.13-6.52,2,1.15,2,1.15-2.57,3.26Zm4.77,2.75-4-2.3,2.56-3.26,2.57-3.26,2,1.16,2,1.15-2.56,3.26Zm9.9-3.76-5.13,6.52-4-2.3,2.57-3.26,2.56-3.26,2,1.15Zm.56-.7-2-1.16-2-1.15,2.56-3.26,2.57-3.25,2,1.15,2,1.15Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M139.34,135.56l-4.78-2.76h0l-4.77-2.75h0l-5.55-3.21-5.69,7.22h0l-.34.45-.22.26h0l-5.34,6.79-6,7.66,4.77,2.76h0l4.77,2.75h0l5.56,3.21,5.68-7.23h0l.35-.44L128,150h0l5.34-6.78ZM134,133.51l4,2.3-5.13,6.52-2-1.15-2-1.15,2.56-3.26Zm-11.6,13.29-2-1.15-2-1.16,2.56-3.25,2.57-3.26,2,1.15,2,1.15L125,143.54Zm10.82-13.74-2.57,3.26-2.56,3.25-2-1.15-2-1.15,2.56-3.26,2.56-3.25Zm-13.9,1.46,5.13-6.52,4,2.3-2.56,3.26-2.57,3.26-2-1.15Zm-.55.7,2,1.16,2,1.15-2.57,3.26L117.64,144l-2-1.15-2-1.15ZM112,151.27,108,149l5.13-6.51,2,1.15,2,1.15L114.51,148Zm.78.45,2.57-3.26,2.56-3.26,2,1.16,2,1.15-2.56,3.26L116.72,154Zm13.89-1.46-5.13,6.52-4-2.31,2.57-3.25,2.56-3.26,2,1.15Zm.56-.71-2-1.15-2-1.15,2.56-3.26,2.57-3.26,2,1.16,2,1.15Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.17,141.46h0l5.55,3.2h0l4.77,2.76,5.68-7.23h0l5.69-7.22h0l6.25-7.93-4.78-2.76h0l-4.77-2.75h0L106,116.32l-5.69,7.22h0l-6.24,7.94h0L88.4,138.7Zm.56-.71-4-2.31,5.13-6.51,4,2.3-2.57,3.26Zm11.6-13.29,2,1.15,2,1.15L106.75,133l-2.56,3.26-2-1.15-2-1.16,2.56-3.25Zm-8.25,10.48,2.56-3.26,2,1.15,2,1.16L98.5,143.5l-4-2.3Zm11.32,1.8-5.13,6.52-4-2.31,5.13-6.51,2,1.15Zm5.69-7.22L109,139l-2-1.15-2-1.15,2.56-3.26,2.57-3.26,2,1.16Zm1.7-9.53,4,2.3-5.13,6.52-2-1.15-2-1.16,2.56-3.25ZM111,120.23l4,2.31-2.57,3.26-2.56,3.25-2-1.15-2-1.15,2.56-3.26Zm-9.9,3.76,5.13-6.51,4,2.3L107.67,123l-2.57,3.26-2-1.15Zm-.55.71,2,1.16,2,1.15L102,130.27l-2.56,3.25-.58-.33-3.41-2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.49,167.83l-4.77-2.76h0l-5.55-3.2-5.9,7.49-5.48,6.95h0l-6.24,7.94,4.77,2.75h0l4.77,2.76h0l5.55,3.2,5.69-7.22h0l5.69-7.23h0l6.24-7.93-4.77-2.75Zm-5.33-2.05,4,2.31-2.56,3.25L127,174.6l-2-1.15-2-1.15L125.6,169Zm-6.82,16-2-1.15-2-1.15,2.57-3.26,2.56-3.26,2,1.16,2,1.15-2.56,3.26Zm2-18.79,4,2.3-2.56,3.26-2.57,3.26-2-1.16-2-1.15Zm-10.82,13.74,5.13-6.52,2,1.15,2,1.15-2.56,3.26-2.57,3.26-2-1.15ZM106.89,184l5.12-6.52,2,1.16,2,1.15L113.44,183l-2.56,3.25Zm8.76,5.06-4-2.31,2.56-3.25,2.57-3.26,2,1.15,2,1.15-2.57,3.26Zm9.9-3.76-5.13,6.51-4-2.3,2.56-3.26,2.57-3.26,2,1.16Zm5.69-7.23-5.13,6.52-2-1.15-2-1.15,2.56-3.26,2.56-3.26,2,1.15Zm1.69-9.52,4,2.3-5.13,6.52-2-1.16-2-1.15,2.57-3.26Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.8,168h0l6.24-7.93-4.77-2.75h0l-4.77-2.76h0l-5.55-3.2-5.69,7.22h0l-5.69,7.22h0l-6.24,7.94,5.55,3.2h0l4,2.31h0l5.55,3.2,5.9-7.49Zm-.78-.45-5.13,6.52-2-1.15-2-1.16,2.56-3.25,2.57-3.26,2,1.15Zm-4.78-2.75-2.56,3.26-2.56,3.25-4-2.3h0l5.13-6.52,2,1.16Zm6.47-6.78,4,2.31-5.13,6.51-2-1.15-2-1.15,2.57-3.26Zm-4.77-2.75,4,2.3-2.56,3.26-2.57,3.26-2-1.15-2-1.15,2.57-3.26ZM100,159l5.13-6.52,4,2.31-2.56,3.26L104,161.32l-2-1.15Zm-5.69,7.22,5.13-6.51,2,1.15,2,1.15-5.13,6.52-2-1.15Zm-.56.71,2,1.15,2,1.16h0l-5.13,6.51-4-2.3Zm3.64,11.58-4-2.31,4.81-6.11.32-.4,3.39,2,.6.34L100,175.27Zm4.77,2.75-4-2.3,2.56-3.26,2.57-3.26,2,1.15,2,1.16Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M95.58,157.47h0l6.24-7.93-4.77-2.76h0L92.28,144h0l-5.55-3.21-6.25,7.94h0l-5.13,6.51h0l-.44.56-.12.15h0l-5.68,7.22L73.88,166h0l4.77,2.75h0l5.55,3.21,5.9-7.49ZM94.8,157l-5.13,6.52-.58-.34-3.41-2,4.81-6.11.32-.4,2,1.15Zm-13.89,1.46,2.56-3.26L86,152l2,1.15,2,1.16-5.13,6.51-2-1.15Zm15.58-11,4,2.31-5.13,6.51-2-1.15-2-1.15,2.57-3.26Zm-4.77-2.75,4,2.3-2.56,3.26-2.57,3.26-2-1.15-2-1.16L89.16,148ZM87,142l4,2.31-2.56,3.26-2.57,3.25-.58-.33-3.41-2ZM76.13,155.72l5.13-6.51,4,2.3-2.56,3.26L80.12,158l-2-1.16Zm-1.69,9.53-4-2.3,5.12-6.52,2,1.15,2,1.16L77,162ZM79.21,168l-4-2.31,2.56-3.26,2.57-3.25,2,1.15,2,1.15-2.57,3.26ZM84,170.76l-4-2.3,2.56-3.26,2.57-3.26,4,2.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,124l2.23-2.83-19.55-11.28-2.57-1.49h0l-14.32-8.26h0l-1.37-.8-16.85-9.72h0l-3.89-2.25-2.22,2.83h0l-17.07,21.67h0l-.27.35L83,139.15h0l-19.28,24.5,3.88,2.24h0l54.66,31.56,20.15-25.59,1.37-1.74h0l18.69-23.74.6-.76h0L180.08,124ZM158,111.18,140.9,132.85l-14.32-8.26,17.06-21.67Zm-55.65,70.68L88,173.6l17.06-21.67,14.31,8.26Zm21-19.41,14.31,8.26-17.06,21.67-14.31-8.26Zm-16-13.36,17.06-21.67,14.32,8.27L121.6,157.36Zm-3.9-2.25-14.32-8.26,17.06-21.68,14.32,8.27Zm22-54.44,14.31,8.26-17.06,21.67-14.32-8.26Zm-38.59,49,14.31,8.26L84.09,171.35l-14.31-8.27Zm38.67,18.2,17.06-21.67,14.32,8.27-17.07,21.67Zm33.61-16.24-14.32-8.26,17.06-21.67,14.32,8.26Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,124l2.23-2.83-19.55-11.28-2.57-1.49h0l-14.32-8.26h0l-1.37-.8-16.85-9.72h0l-3.89-2.25-2.22,2.83h0l-17.07,21.67h0l-.27.35L83,139.15h0l-19.28,24.5,3.88,2.24h0l54.66,31.56,20.15-25.59,1.37-1.74h0l18.69-23.74.6-.76h0L180.08,124ZM158,111.18,140.9,132.85l-14.32-8.26,17.06-21.67Zm-55.65,70.68L88,173.6l17.06-21.67,14.31,8.26Zm21-19.41,14.31,8.26-17.06,21.67-14.31-8.26Zm-16-13.36,17.06-21.67,14.32,8.27L121.6,157.36Zm-3.9-2.25-14.32-8.26,17.06-21.68,14.32,8.27Zm22-54.44,14.31,8.26-17.06,21.67-14.32-8.26Zm-38.59,49,14.31,8.26L84.09,171.35l-14.31-8.27Zm38.67,18.2,17.06-21.67,14.32,8.27-17.07,21.67Zm33.61-16.24-14.32-8.26,17.06-21.67,14.32,8.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.42,401.1a6.15,6.15,0,0,0-.64,3.13,14.83,14.83,0,0,1,.36,4.32c-.25,2.14-.74,2.81-1,4.32a5.34,5.34,0,0,0,.84,4c.88,1.44,2.84,2.58,6.69,2.44,3.12-.11,4.37-1.71,4.44-3.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,396.66a7.31,7.31,0,0,0-.19,1.21c-.12.72-.33,1.41-.5,2.12-.05.19-.09.37-.13.56a22.78,22.78,0,0,0,0,4.37,24.8,24.8,0,0,1-.9,5.1c-.7,3-.81,5.05,1.84,7.15,1.39,1.1,2.92,1.14,4.69,1.19a7.41,7.41,0,0,0,3.9-.95c1.14-.83,1.12-1.53,1.13-1.8.11-3.22-1-7-1.29-10.17a16.28,16.28,0,0,1-.06-2.61c.11-1.06.48-2.12.6-3.19a1.82,1.82,0,0,0-.15-1.18,1.88,1.88,0,0,0-1.43-.65c-1.41-.18-2.82-.32-4.24-.42a1.25,1.25,0,0,0-1,.19,1.77,1.77,0,0,0-.35,1c-.07.36-.34.77-.7.7a.59.59,0,0,1-.43-.53c0-.24-.14-2.1-.13-2.35C383,396.43,382.5,396.35,382.33,396.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.16,407.33a2.36,2.36,0,0,1,0,1.77c-.22.53-2.86,2.16-6.51,2.06a15.18,15.18,0,0,1-7.63-2.32,8.64,8.64,0,0,0-4.68-1c-1.81,0-3.92-.68-4.53-1.5a4.26,4.26,0,0,1,0-2.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,396.56a7.33,7.33,0,0,1,.38.8,6.43,6.43,0,0,0,2,2.5,20.52,20.52,0,0,0,4,2.17c.9.4,1.84.52,2.75.83a16.13,16.13,0,0,1,2.95,1.3,2.63,2.63,0,0,1,.16,4.34,12.86,12.86,0,0,1-8.94,1c-2.14-.51-4.57-2.67-7.35-2.78-1.77-.06-5.12-.42-6.31-1.71-.43-1.93,0-2.48.44-4.12a13.5,13.5,0,0,0,.33-2.83c0-.5-.33-1.93.72-2.11l.11,1.08s.19.36,1.28.56c.36.06.63.52.83.94s.3.75.66.74a.68.68,0,0,0,.54-.43c.1-.22.13-.47.21-.7a2.76,2.76,0,0,1,1.65-1.64,8.38,8.38,0,0,1,1.93-.4c.5-.08.91-.29,1.36.13A1.31,1.31,0,0,1,416,396.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,314c-1.35,13.17-1.33,19.42-3.06,45.7a130.51,130.51,0,0,0-1.9,15.2c-.38,6.37-1.28,25.6-1.28,25.6s5.14,4.22,11.09,2.27c0,0,5.39-28.25,7.27-37.07,1.8-8.46,3.62-19.09,3.62-19.09l.85,13.18s-.24,5.25-.07,13.09c.09,4.19,2.11,26.88,2.11,26.88s7.21,3.28,12.08-.93c0,0,.35-36.79.43-40.59.08-4.33-.67-47.88-.67-47.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,346.64,406,328.7s5.7-.5,8.84-3.67c0,0-.56,3.11-7.72,5l-2.91,15-.61,14.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.89,397.06a11.76,11.76,0,0,0,7.91,2.85s-4.91-.73-7.85-4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.36,397.11s5,1.76,9.27.42c0,0-3.28,2.2-9.2.39Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.21,275.76c2-.23,4.19,1.35,5.28,3.67,2,4.31,6.13,13.9,9.43,19.72l12.47-2.74-3.38,9.5a90,90,0,0,1-9.76,2.78c-3.22.54-4.22,0-6.1-2.7-1.62-2.34-8.3-14.23-8.3-14.23Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,292.53h0l-.66-.62h0a.78.78,0,0,0-.7-.11l-7.47,1.72a2.73,2.73,0,0,0-1.72,1.48l-5.93,15.14a.7.7,0,0,0,.06.78h0l.68.63h0a.73.73,0,0,0,.7.11l7.47-1.71a2.73,2.73,0,0,0,1.73-1.49c1.16-3,4.76-12.16,5.93-15.13C446.37,293,446.32,292.68,446.13,292.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.15,294.54a2.66,2.66,0,0,0-.9,1.09l-5.93,15.13a.72.72,0,0,0,0,.77l-.64-.59h0a.68.68,0,0,1-.07-.78L435.59,295a2.58,2.58,0,0,1,.83-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,310.76l5.93-15.13a2.7,2.7,0,0,1,1.72-1.48l7.47-1.72c.7-.16,1.05.25.79.91-1.17,3-4.77,12.16-5.93,15.13a2.73,2.73,0,0,1-1.73,1.49l-7.47,1.71C430.41,311.83,430.06,311.42,430.32,310.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.11,296.2a3.65,3.65,0,0,1,2.26,3.74c-.43,3.46-2.52,9-8,6.87-2.8-1.07-3.39-4.83-.81-5.57,4.52-1.31,5.73-2.89,5.73-2.89Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.16,274.69c3.17.67,5,1.19,7,5s7.74,16.94,7.74,16.94l-7.74,7-7-12.35Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.16,274.69c3.17.67,5,1.19,7,5s7.74,16.94,7.74,16.94l-7.74,7-7-12.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.46,299c-3.5,1-7.08,4.07-7.15,7.19l.32.44a1,1,0,0,1-1.38,0,18.21,18.21,0,0,1-2.8-4.37c-.23-.65.71-2.59,3-4.54s5.73-2.1,6.46-1.77C429.1,296.67,429.46,299,429.46,299Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.33,316.58s-.31,2.38.08,3,9,2.62,18.46,1.68,12.35-3.42,12.69-4a5.73,5.73,0,0,0,0-3.24Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.33,316.58s-.31,2.38.08,3,9,2.62,18.46,1.68,12.35-3.42,12.69-4a5.73,5.73,0,0,0,0-3.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,286c-1.28-9.37-1.35-11.56-8.24-11.84l-10.25-.68c-2.19.57-9,2.21-12,3.1s-3,7.59-2.32,12,1.57,8,1.28,15.17c-.12,7-1.92,10.77-.18,12.64,6.38,4,24.89,2.79,31.62-1.27,1.42-.7,0-6.06.1-10.4C418,297.31,418.18,288.8,417.8,286Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.12,274s3.52,3.19,2.35,6.18-6.26,3.5-10.23.67-3.62-6.15-3.62-6.15l1.49-.46a4.93,4.93,0,0,0,.82,2c.63.75,8,3.84,8.13,4.74,0,0,1.14-2.17,1.47-3s-1.28-4.14-1.28-4.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5,248.37a5.23,5.23,0,0,0,.13-.87,3.6,3.6,0,0,0-1.09-2.86,2.45,2.45,0,0,0-2.92-.28,3.5,3.5,0,0,0-3-3.58,7.06,7.06,0,0,0-3.31,1.14,42.2,42.2,0,0,1-5.05,1.83,13.36,13.36,0,0,0-4.72,2.48,5.83,5.83,0,0,0-2.08,4.74,4.18,4.18,0,0,0-2.23,3.72c-.1,2.32,1,4.49,1.84,6.57,0,0,2.21,5.28,2.74,6.32.62,1.21,1.07,2.22,1.07,2.22l-.21-3.82a16,16,0,0,0,4.45-.78,29.94,29.94,0,0,0,4.13-1.95,49.94,49.94,0,0,0,7.38-5.3,8,8,0,0,0,2.86-3.64,4.24,4.24,0,0,0-.84-3.84A7.71,7.71,0,0,0,415.5,248.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.86,251.14a7.44,7.44,0,0,1-2.55,5.34,13.54,13.54,0,0,1,.1,4.62,2.49,2.49,0,0,1-.34.92,1.12,1.12,0,0,1-.82.52c-.44,0-.63-.24-.76-.59a13.4,13.4,0,0,0-.68-1.3,3.25,3.25,0,0,0-.4-.5,2.19,2.19,0,0,0-3.62.75c-1,2.21.8,5.18,2.43,5.6a2.58,2.58,0,0,0,2.84-1l.27,9.81c1.51,1.58,8.08,3.77,9.73,5.64.75-1.27,2.87-4.4.07-6.18l-.07-3.21a22.86,22.86,0,0,0,4.51-.22c1.45-.28,2.78-1.53,3.13-3.79a39.07,39.07,0,0,0,0-12.77c-.53-2.61-1.94-4.34-2.72-4.73,0,.56-.44,1.93-3.25,2.32A15.23,15.23,0,0,1,399.86,251.14Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.06,271.57a15.61,15.61,0,0,1-5.86-1.35,5.51,5.51,0,0,1-2.27-2.1,7.31,7.31,0,0,0,1.33,2.52c1.21,1.44,6.83,2.24,6.83,2.24Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.3,259.26a.91.91,0,1,1-1.82.05.91.91,0,1,1,1.82-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.63,256.05l-2.27,1.4a1.39,1.39,0,0,1,.45-1.88A1.3,1.3,0,0,1,403.63,256.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.41,265.34l3.12,1.06a1.62,1.62,0,0,1-2.06,1.1A1.74,1.74,0,0,1,404.41,265.34Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.39,266.27a1.48,1.48,0,0,0-1-.17,1.63,1.63,0,0,0,1.79,1.47A1.52,1.52,0,0,0,405.39,266.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.74,256.88l-2.44-.94a1.26,1.26,0,0,1,1.65-.74A1.34,1.34,0,0,1,412.74,256.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.13,258.88a.92.92,0,1,1-.95-.93A1,1,0,0,1,412.13,258.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.31 256.9 407.3 263.8 410.84 262.99 406.31 256.9",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.06,281c-1.13-.68-3.38-2.2-4.48-.77s-1.9,3.09-2.72,2.85a11.46,11.46,0,0,1-4.9-4.52,8.91,8.91,0,0,1-.83-3.47,26.69,26.69,0,0,0,1.58-2.56c.46-.92.79-1.36,1.5-1.41l.07,2.31a9.06,9.06,0,0,0,2.31,2.6C400.6,277.41,404.58,277.78,406.06,281Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.06,281c.67-.61,1.65-2.18,2.75-1.87S411,281.55,411,281a18.09,18.09,0,0,0-1.92-5.41c-.84-1.24-2.28-3.49-3-3.44l.05,2.67s1.31,1.65,1.16,2.65S406.2,280,406.06,281Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,305.33c0-2.08,1.78-10.23,4.31-18.59,2.4-7.93,6.09-9.14,10.1-9.84a23.85,23.85,0,0,1,1.48,13.71L383,306",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.94,328.75a3.94,3.94,0,0,1-2.15-1.83,5,5,0,0,0,2.37.61c1.41,0,1.76-.77,1.76-1.22s-.67-.56-1.91-1.23c-1.06-.56-1.79-1.33-3.5-2.25-1.18-.63-1.62-.57-2.42-1.42-1.26-1.34-1.64-4-2.86-7.54a31.08,31.08,0,0,1-1.52-5.52l-10.06-3.68c-.7,3,.36,5.66,3.45,12.8.82,2.34,4.27,8.25,5.65,10.56,1.87,3.12,3.24,4.9,4.94,6.23A5.31,5.31,0,0,0,392.94,328.75Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,276.6c-2.11.24-6.05,1.21-8.11,4.47s-4.51,14-5.42,17.34a30.84,30.84,0,0,0-.82,7.38s3.43,2.11,10,.57c1-3.11,3.87-9.73,6.52-15.75C389.48,290.61,391,280,387.29,276.6Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.29,276.6c-2.11.24-6.05,1.21-8.11,4.47s-4.51,14-5.42,17.34a30.84,30.84,0,0,0-.82,7.38s3.43,2.11,10,.57c1-3.11,3.87-9.73,6.52-15.75C389.48,290.61,391,280,387.29,276.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.47,304.89c.38.23.57.65.34,1.68s.09,3.41-.4,3.82-2.46.93-5.31.66c-3.18-.3-5.73-1.84-6.15-3.35a16.23,16.23,0,0,1,.29-6.08c.34-1.34,1.09-1.16,1.09-1.16l-.18,1.31s1,2,4.31,3.08a18.84,18.84,0,0,0,5.64,1.08Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.07,147l2.5-4.71-2-5.82v-3.57l6.16,3.57v3.56l-2.65,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.07,147l2.5-4.71-2-5.82v-3.57l6.16,3.57v3.56l-2.65,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,111.38a4.1,4.1,0,0,1,1.85-3.21l1.51-.87a4.09,4.09,0,0,1,3.7,0l18.76,10.81a4.1,4.1,0,0,1,1.85,3.21v20.81a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.09,4.09,0,0,1-3.7,0l-6.76-3.89-2.65,4.59a.39.39,0,0,1-.71-.07l-2.8-8.08-5.85-3.36a4.09,4.09,0,0,1-1.85-3.2Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.66,142.13a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.12,4.12,0,0,1-3.39.15c.87.33,1.54-.16,1.54-1.22V124.32a3.82,3.82,0,0,0-.54-1.82l5.2-3a3.75,3.75,0,0,1,.54,1.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.05,110.85c.22-.79.94-1,1.79-.54l18.77,10.81a3.62,3.62,0,0,1,1.3,1.38l5.21-3a3.72,3.72,0,0,0-1.31-1.38L350.05,107.3a4.15,4.15,0,0,0-3.7,0l-1.51.87A4.16,4.16,0,0,0,343.05,110.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.47,124.73a.55.55,0,0,1,.24.08l6,3.46a2.92,2.92,0,0,1,1.15,2.26v7.59c0,.37-.11.6-.19.6a.59.59,0,0,1-.24-.08l-6-3.46a2.94,2.94,0,0,1-1.15-2.26v-7.59c0-.37.11-.6.19-.6m2.29,6.83-.53.91a.73.73,0,0,0,.26,1L355,134.9a.65.65,0,0,0,.36.1.75.75,0,0,0,.46-.17A.71.71,0,0,0,356,134l-.57-1.63a1.79,1.79,0,0,0,.37-1.16,3.13,3.13,0,0,0-1.37-2.56,1.48,1.48,0,0,0-.77-.22c-.64,0-1.33.5-1.33,1.61a3.21,3.21,0,0,0,.39,1.48M350.47,124c-.53,0-.91.49-.91,1.32v7.59a3.62,3.62,0,0,0,1.51,2.88l6,3.46a1.17,1.17,0,0,0,.6.18c.54,0,.91-.49.91-1.32v-7.59a3.59,3.59,0,0,0-1.51-2.88l-6-3.46a1.14,1.14,0,0,0-.6-.18Zm4.89,10.27-2.5-1.45.74-1.29a2.51,2.51,0,0,1-.51-1.46c0-.56.25-.89.61-.89a.86.86,0,0,1,.41.12,2.44,2.44,0,0,1,1,1.94c0,.5-.2.82-.51.88l.75,2.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,127.1l-1.06-.61v-3.3a5.32,5.32,0,0,0-2-3.92c-1.29-.81-1.9.29-1.9,1.66v3.3l-.91-.53v-3.29c0-2.16,1.32-3.16,2.94-2.22a7,7,0,0,1,2.94,5.62Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.17,90.52l2.51-4.71-2-5.82V76.43L262.83,80v3.56l-2.65,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,90.52l2.51-4.71-2-5.82V76.43L262.83,80v3.56l-2.65,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.1,54.86A4.1,4.1,0,0,1,247,51.65l1.51-.87a4.09,4.09,0,0,1,3.7,0L270.92,61.6a4.09,4.09,0,0,1,1.85,3.2V85.61a4.1,4.1,0,0,1-1.85,3.21l-1.5.86a4.09,4.09,0,0,1-3.7,0L259,85.79l-2.65,4.59a.39.39,0,0,1-.71-.07l-2.8-8.07L247,78.87a4.09,4.09,0,0,1-1.85-3.2Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,85.61a4.1,4.1,0,0,1-1.85,3.21l-1.5.86a4.12,4.12,0,0,1-3.39.15c.87.33,1.54-.16,1.54-1.21V67.8A3.73,3.73,0,0,0,267,66l5.21-3a3.82,3.82,0,0,1,.54,1.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.16,54.33c.22-.78.93-1,1.79-.54L265.72,64.6A3.77,3.77,0,0,1,267,66l5.2-3a3.62,3.62,0,0,0-1.3-1.38L252.16,50.79a4.09,4.09,0,0,0-3.7,0l-1.51.87A4.08,4.08,0,0,0,245.16,54.33Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.79,80.65a6.57,6.57,0,0,1-2.74-5.23c0-1.23.45-2.09,1.21-2.33V64c0-1.12.69-1.64,1.53-1.15a3.68,3.68,0,0,1,1.53,2.92v9a6.91,6.91,0,0,1,1.21,3.73C258.53,80.6,257.3,81.52,255.79,80.65Zm0-17.13c-.58-.34-1.06,0-1.06.8v9.39l-.11,0c-.69.15-1.1.88-1.1,2A5.43,5.43,0,0,0,255.79,80c1.25.72,2.27,0,2.27-1.71a5.71,5.71,0,0,0-1.1-3.22l-.12-.16V65.54A2.54,2.54,0,0,0,255.79,63.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.5,76.25c0-1,.57-1.39,1.29-1a3.12,3.12,0,0,1,1.29,2.47c0,1-.58,1.39-1.29,1A3.08,3.08,0,0,1,254.5,76.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.79,77.22a.84.84,0,0,1-.36-.68V66.12c0-.26.16-.38.36-.27a.86.86,0,0,1,.36.69V77C256.15,77.22,256,77.34,255.79,77.22Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.8,109.36l2.51-4.71-2-5.82V95.27l6.17,3.56v3.56L292.81,107a.35.35,0,0,1-.18.16h0Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,109.36l2.51-4.71-2-5.82V95.27l6.17,3.56v3.56L292.81,107a.35.35,0,0,1-.18.16h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.73,73.7a4.1,4.1,0,0,1,1.85-3.21l1.51-.87a4.09,4.09,0,0,1,3.7,0l18.76,10.82a4.07,4.07,0,0,1,1.85,3.2v20.81a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.09,4.09,0,0,1-3.7,0l-6.76-3.89-2.65,4.59a.39.39,0,0,1-.71-.07l-2.8-8.08-5.85-3.36a4.09,4.09,0,0,1-1.85-3.2Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.4,104.45a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.12,4.12,0,0,1-3.39.15c.87.33,1.54-.16,1.54-1.21V86.64a3.73,3.73,0,0,0-.55-1.82l5.21-3a3.82,3.82,0,0,1,.54,1.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.79,73.17c.22-.78.94-1,1.79-.54l18.77,10.81a3.77,3.77,0,0,1,1.3,1.38l5.2-3a3.62,3.62,0,0,0-1.3-1.38L284.79,69.62a4.15,4.15,0,0,0-3.7,0l-1.51.88A4.08,4.08,0,0,0,277.79,73.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.8,95.36c0-1.24.75-1.81,1.68-1.28a4,4,0,0,1,1.69,3.22c0,1.24-.76,1.81-1.69,1.28A4,4,0,0,1,286.8,95.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.18,96.86a.63.63,0,0,1-.57-.39s-1.46-3.55-3.81-4.9a2.39,2.39,0,0,0-3.26.34.63.63,0,0,1-.88.11.61.61,0,0,1-.11-.86,3.64,3.64,0,0,1,4.88-.67c2.71,1.57,4.27,5.35,4.33,5.51a.62.62,0,0,1-.34.81A.69.69,0,0,1,293.18,96.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.56,92.83a.62.62,0,0,1-.6-.48,16,16,0,0,0-6.7-7.58C285.51,82,282,86,281.85,86.15a.63.63,0,0,1-.88.07.62.62,0,0,1-.06-.88s4.31-4.91,10-1.65a16.8,16.8,0,0,1,7.28,8.37.63.63,0,0,1-.46.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.44,94.68a.62.62,0,0,1-.59-.43,14.28,14.28,0,0,0-5.3-6.15,4.72,4.72,0,0,0-5.91.9.64.64,0,0,1-.88,0,.62.62,0,0,1-.05-.88A6,6,0,0,1,290.17,87,15.24,15.24,0,0,1,296,93.88a.63.63,0,0,1-.42.78A.55.55,0,0,1,295.44,94.68Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.44,128.2l2.5-4.71-2-5.82v-3.56l6.16,3.56v3.56l-2.65,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.44,128.2l2.5-4.71-2-5.82v-3.56l6.16,3.56v3.56l-2.65,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.36,92.54a4.1,4.1,0,0,1,1.85-3.21l1.51-.87a4.09,4.09,0,0,1,3.7,0l18.76,10.81a4.1,4.1,0,0,1,1.85,3.21v20.81a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.09,4.09,0,0,1-3.7,0l-6.76-3.89-2.65,4.59a.39.39,0,0,1-.71-.07l-2.8-8.08-5.85-3.36a4.09,4.09,0,0,1-1.85-3.2Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,123.29a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.12,4.12,0,0,1-3.39.15c.87.33,1.54-.16,1.54-1.21V105.48a3.82,3.82,0,0,0-.54-1.82l5.2-3a3.68,3.68,0,0,1,.54,1.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.42,92c.22-.79.94-1,1.79-.54L331,102.28a3.69,3.69,0,0,1,1.3,1.38l5.2-3a3.62,3.62,0,0,0-1.3-1.38L317.42,88.46a4.15,4.15,0,0,0-3.7,0l-1.51.88A4.12,4.12,0,0,0,310.42,92Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.71,100.34a2.52,2.52,0,0,1,1,.24c2.52,1.08,4.82,5.19,4.82,8.62a3.79,3.79,0,0,1-1.09,3.06,4.86,4.86,0,0,0-1.75,3.31l-2.17-1.25a14.06,14.06,0,0,0-1.64-5.72,10.61,10.61,0,0,1-1.26-5.42c.12-1.75.92-2.84,2.07-2.84m0-.78c-1.56,0-2.69,1.33-2.85,3.57a11.27,11.27,0,0,0,1.35,5.83,13,13,0,0,1,1.55,5.75v.07l3.65,2.1v-.07a4.78,4.78,0,0,1,1.52-3.93,4.42,4.42,0,0,0,1.4-3.68c0-3.73-2.42-8.11-5.29-9.34a3.39,3.39,0,0,0-1.33-.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.76 108.5 319.84 109.69 321.17 107.83 320.16 105.47 323.33 104.5 321.8 106.48 322.76 108.5",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.41 120 319.76 117.9 319.76 115.65 323.41 117.76 323.41 120",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.7,165.88l2.5-4.72-2-5.81v-3.57l6.17,3.57v3.56l-2.66,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.7,165.88l2.5-4.72-2-5.81v-3.57l6.17,3.57v3.56l-2.66,4.59a.35.35,0,0,1-.18.16h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.62,130.21a4.09,4.09,0,0,1,1.85-3.2l1.51-.87a4.09,4.09,0,0,1,3.7,0L401.44,137a4.08,4.08,0,0,1,1.85,3.21V161a4.09,4.09,0,0,1-1.85,3.2l-1.5.87a4.09,4.09,0,0,1-3.7,0l-6.76-3.89-2.65,4.59a.39.39,0,0,1-.71-.07l-2.8-8.08-5.85-3.36a4.09,4.09,0,0,1-1.85-3.2Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.29,161a4.06,4.06,0,0,1-1.85,3.2l-1.5.87a4.16,4.16,0,0,1-3.39.15c.87.33,1.54-.16,1.54-1.22V143.16a3.82,3.82,0,0,0-.54-1.82l5.2-3a3.75,3.75,0,0,1,.54,1.83Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.68,129.69c.22-.79.94-1,1.79-.54L396.24,140a3.62,3.62,0,0,1,1.3,1.38l5.21-3a3.72,3.72,0,0,0-1.31-1.38l-18.76-10.82a4.15,4.15,0,0,0-3.7,0l-1.51.87A4.14,4.14,0,0,0,375.68,129.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,139.79a2.2,2.2,0,0,0-1.13-.35c-1,0-1.72.94-1.72,2.51a6.82,6.82,0,0,0,2.85,5.45,2.24,2.24,0,0,0,1.14.35c1,0,1.72-.94,1.72-2.51A6.83,6.83,0,0,0,384.59,139.79Zm1.14,7.14a1.54,1.54,0,0,1-.73-.23,6,6,0,0,1-2.45-4.75c0-.78.24-1.69.91-1.69a1.57,1.57,0,0,1,.73.23,6.07,6.07,0,0,1,2.45,4.75C386.64,146,386.4,146.93,385.73,146.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.45,140.58c-.23-.13-.42,0-.42.32a1,1,0,0,0,.42.8c.23.13.42,0,.42-.32A1,1,0,0,0,387.45,140.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.26,156.61c-.42-.25-.78.45-.87,1.6l-2.29-1.33a3.24,3.24,0,0,1-1.36-2.58v-1.21l1.94,1.12a1.62,1.62,0,0,0,.79.24c.72,0,1.22-.66,1.22-1.76V145a4.81,4.81,0,0,0-2-3.84l-4.2-2.43-5.77-3.33a1.63,1.63,0,0,0-.8-.24c-.71,0-1.21.66-1.21,1.76v7.69a4.85,4.85,0,0,0,2,3.85l4.1,2.36,1.67,1h0l1.33.78v1.2a5.5,5.5,0,0,0,2.29,4.37l2.29,1.32a3.88,3.88,0,0,0,.87,2.61c.5.29.9-.7.9-2.21S394.76,156.89,394.26,156.61Zm-4.52-6.67v-7.69a4.39,4.39,0,0,0-.26-1.42l1.79,1a4.05,4.05,0,0,1,1.61,3.14v7.69c0,.47-.14.95-.41.95a.93.93,0,0,1-.39-.13l-3.1-1.79A2.11,2.11,0,0,0,389.74,149.94Zm-1.69,1.27a1.09,1.09,0,0,1-.57-.17l-1.67-1-.23-.13h0l-3.87-2.24a3.48,3.48,0,0,1-1.45-2.77v-7.69c0-.8.36-1.28.87-1.28a1.18,1.18,0,0,1,.58.18l3.87,2.23h0l1.9,1.1h0a3.48,3.48,0,0,1,1.45,2.77v7.69C388.93,150.74,388.57,151.21,388.05,151.21Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.7,256.75l11.93,6.91-4.74,10.65a1.08,1.08,0,0,1-.45.51l-4.1,2.37a1.1,1.1,0,0,1-1.6-.64l-5.15-17.43Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.7,256.75l11.93,6.91-4.74,10.65a1.08,1.08,0,0,1-.45.51l-4.1,2.37a1.1,1.1,0,0,1-1.6-.64l-5.15-17.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.53,266l-4.74,10.65a1.1,1.1,0,0,1-2.05-.13l-5.15-17.43Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.68,154.4l45,26a2.29,2.29,0,0,1,1,1.79v91.07a2.27,2.27,0,0,1-1,1.78l-3.7,2.07a2.29,2.29,0,0,1-2.07,0l-45-26a2.28,2.28,0,0,1-1-1.79V158.25a2.26,2.26,0,0,1,1-1.78l3.7-2.08A2.32,2.32,0,0,1,431.68,154.4Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.88,158.06c.09-.52.51-.71,1-.41l45,26a2.09,2.09,0,0,1,.73.77l5.75-3.29a2,2,0,0,0-.71-.73l-45-26a2.32,2.32,0,0,0-2.07,0l-3.7,2.07A2.32,2.32,0,0,0,424.88,158.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.93,276.49V185.41a2.26,2.26,0,0,0-1-1.78l-45-26c-.57-.33-1-.06-1,.6v91.07a2.28,2.28,0,0,0,1,1.79l45,26C471.47,277.41,471.93,277.15,471.93,276.49Z",
    style: {
      fill: "#22AEE9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.9,277.08a2.35,2.35,0,0,0,2.07,0l3.7-2.07a2.26,2.26,0,0,0,1-1.78V182.17a2.15,2.15,0,0,0-.33-1.06l-5.75,3.29a2,2,0,0,1,.3,1v91.07C471.93,277.09,471.51,277.44,470.9,277.08Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M431.44,216a2,2,0,0,1,.61.54,4,4,0,0,1,.47.77,4.85,4.85,0,0,1,.31.85,3,3,0,0,1,.12.77.28.28,0,0,1,0,.15s-.05,0-.08,0l-.67-.38a.38.38,0,0,1-.11-.11,1.5,1.5,0,0,1-.09-.18l-.05-.13a1.89,1.89,0,0,0-.1-.21,1.07,1.07,0,0,0-.15-.22.71.71,0,0,0-.23-.19.48.48,0,0,0-.18-.08.3.3,0,0,0-.16,0,.15.15,0,0,0-.11.1.46.46,0,0,0-.05.23.84.84,0,0,0,.05.29,1,1,0,0,0,.17.29,2.17,2.17,0,0,0,.3.35c.13.13.28.29.47.47a4.31,4.31,0,0,1,.49.58,3.13,3.13,0,0,1,.35.65,3,3,0,0,1,.21.75,5,5,0,0,1,.07.9,2.86,2.86,0,0,1-.12.89,1,1,0,0,1-.33.52.69.69,0,0,1-.5.17,1.34,1.34,0,0,1-.63-.21,2.31,2.31,0,0,1-.63-.55,3.78,3.78,0,0,1-.5-.79,4.63,4.63,0,0,1-.32-.88,4,4,0,0,1-.13-.86.26.26,0,0,1,0-.14s0,0,.07,0l.67.39a.27.27,0,0,1,.11.1.76.76,0,0,1,.09.16l.06.17a1.86,1.86,0,0,0,.28.53.92.92,0,0,0,.26.22.7.7,0,0,0,.45.14c.12,0,.19-.12.19-.33a.82.82,0,0,0-.07-.3,2,2,0,0,0-.2-.31c-.09-.11-.2-.23-.34-.37l-.49-.49a3.33,3.33,0,0,1-.77-1.21,4.83,4.83,0,0,1-.24-1.59,2.78,2.78,0,0,1,.1-.8,1.24,1.24,0,0,1,.29-.56.67.67,0,0,1,.45-.24A1.06,1.06,0,0,1,431.44,216Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.5,223.91a1.72,1.72,0,0,1-.07-.21l-.48-2v3.48a.29.29,0,0,1,0,.17s-.06,0-.09,0l-.68-.39a.22.22,0,0,1-.09-.14.54.54,0,0,1,0-.22v-6.78a.3.3,0,0,1,0-.18.06.06,0,0,1,.09,0l.6.35a.29.29,0,0,1,.15.2,1.25,1.25,0,0,1,.07.21l.83,3.38.83-2.43a.45.45,0,0,1,.06-.13.1.1,0,0,1,.15,0l.6.34a.27.27,0,0,1,.1.14.78.78,0,0,1,0,.22v6.79a.39.39,0,0,1,0,.17.07.07,0,0,1-.1,0l-.67-.39a.27.27,0,0,1-.1-.14.54.54,0,0,1,0-.22v-3.48l-.48,1.46a.83.83,0,0,1-.07.13.08.08,0,0,1-.12,0l-.33-.19A.3.3,0,0,1,435.5,223.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.57,221.34a.44.44,0,0,1,.15.21,1.62,1.62,0,0,1,.08.27l1.11,7.26c0,.08,0,.13,0,.17a.26.26,0,0,1,0,.14.06.06,0,0,1-.08,0l-.65-.38a.34.34,0,0,1-.14-.17,1.08,1.08,0,0,1-.06-.2l-.14-1-1.36-.78-.14.78a.39.39,0,0,1-.06.15s-.07,0-.14,0l-.65-.37a.35.35,0,0,1-.08-.11.58.58,0,0,1,0-.19,1.15,1.15,0,0,1,0-.14l1.12-6a.4.4,0,0,1,.07-.19.1.1,0,0,1,.16,0Zm-.83,4.11.83.48-.42-2.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.24,223.46a2.39,2.39,0,0,1,.61.49,3.31,3.31,0,0,1,.45.71,4.42,4.42,0,0,1,.29.91,6.6,6.6,0,0,1,.1,1.13,3.76,3.76,0,0,1-.16,1.21.84.84,0,0,1-.45.54l.63,2.86a.69.69,0,0,1,0,.13.2.2,0,0,1,0,.14.05.05,0,0,1-.08,0l-.69-.4a.34.34,0,0,1-.15-.18,2,2,0,0,1-.07-.23l-.56-2.57-.47-.27v2.24a.3.3,0,0,1-.05.18.06.06,0,0,1-.09,0l-.67-.39a.27.27,0,0,1-.1-.14.57.57,0,0,1,0-.22v-6.79a.29.29,0,0,1,0-.17.07.07,0,0,1,.1,0Zm-.57,2.85.57.33c.15.08.26.1.36,0s.14-.24.14-.53a1.48,1.48,0,0,0-.14-.69.92.92,0,0,0-.36-.37l-.57-.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.26,226.35a.27.27,0,0,1,.1.14.57.57,0,0,1,0,.22v1.12a.29.29,0,0,1,0,.17.07.07,0,0,1-.1,0l-.9-.52v5.39a.29.29,0,0,1,0,.17.07.07,0,0,1-.1,0l-.67-.39a.23.23,0,0,1-.1-.14.78.78,0,0,1,0-.22V227l-.9-.52a.22.22,0,0,1-.09-.14.54.54,0,0,1,0-.22V225a.3.3,0,0,1,0-.18.06.06,0,0,1,.09,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.35,229.29a.26.26,0,0,1,.09.14.54.54,0,0,1,0,.22v6.78a.3.3,0,0,1,0,.18.06.06,0,0,1-.09,0l-.67-.39a.27.27,0,0,1-.1-.14.54.54,0,0,1,0-.22v-2.57l-1.14-.66v2.57a.3.3,0,0,1,0,.18.07.07,0,0,1-.1,0l-.67-.39a.26.26,0,0,1-.09-.14.51.51,0,0,1,0-.22V227.9a.27.27,0,0,1,0-.17.06.06,0,0,1,.09,0l.67.39a.23.23,0,0,1,.1.14.54.54,0,0,1,0,.22V231l1.14.65V229.1a.29.29,0,0,1,0-.17.07.07,0,0,1,.1,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.46,232.68a5.22,5.22,0,0,1,.12-1,2,2,0,0,1,.32-.72.8.8,0,0,1,.49-.33,1,1,0,0,1,.67.16,2.24,2.24,0,0,1,.66.61,3.86,3.86,0,0,1,.49.9,5.68,5.68,0,0,1,.32,1.08,7.74,7.74,0,0,1,.12,1.18c0,.3,0,.62,0,.95s0,.64,0,.92a5.11,5.11,0,0,1-.12,1,2,2,0,0,1-.32.73.8.8,0,0,1-.49.33,1,1,0,0,1-.66-.17,2.12,2.12,0,0,1-.67-.6,3.86,3.86,0,0,1-.49-.9,5.91,5.91,0,0,1-.32-1.08,7.87,7.87,0,0,1-.12-1.18c0-.3,0-.61,0-.93S455.45,233,455.46,232.68Zm2.25,3.11c0-.12,0-.26,0-.42v-.93c0-.16,0-.29,0-.42a4.18,4.18,0,0,0-.06-.51,3,3,0,0,0-.12-.45,1.31,1.31,0,0,0-.2-.37,1,1,0,0,0-.27-.26.39.39,0,0,0-.28-.06.3.3,0,0,0-.2.14,1,1,0,0,0-.12.31,2,2,0,0,0,0,.46c0,.11,0,.24,0,.39v.94c0,.16,0,.3,0,.43a3.22,3.22,0,0,0,.17,1,1.1,1.1,0,0,0,.48.62c.21.12.36.1.47-.07A1.78,1.78,0,0,0,457.71,235.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.16,238.73a1.28,1.28,0,0,1-.07-.21l-.48-2V240a.4.4,0,0,1,0,.18.07.07,0,0,1-.1,0l-.67-.39a.27.27,0,0,1-.1-.14.57.57,0,0,1,0-.22v-6.79a.29.29,0,0,1,0-.17.07.07,0,0,1,.1,0l.59.34a.39.39,0,0,1,.16.21l.06.2.83,3.39.83-2.43a.57.57,0,0,1,.07-.13q0-.09.15,0l.59.35a.23.23,0,0,1,.1.14.54.54,0,0,1,0,.22v6.78a.3.3,0,0,1,0,.18.07.07,0,0,1-.1,0l-.67-.39a.21.21,0,0,1-.09-.14.59.59,0,0,1-.05-.22v-3.48l-.48,1.46a.42.42,0,0,1-.07.13s-.06.05-.12,0l-.32-.19A.3.3,0,0,1,461.16,238.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.94,242.23a.24.24,0,0,1,.09.15.54.54,0,0,1,.05.22v1.11a.3.3,0,0,1-.05.18.05.05,0,0,1-.09,0l-2.43-1.4a.19.19,0,0,1-.09-.13.64.64,0,0,1-.05-.23v-6.78a.3.3,0,0,1,.05-.18.06.06,0,0,1,.09,0l2.39,1.38a.26.26,0,0,1,.09.14.57.57,0,0,1,0,.22V238a.29.29,0,0,1,0,.17.06.06,0,0,1-.09,0l-1.58-.91v1.13l1.46.85a.27.27,0,0,1,.1.14.57.57,0,0,1,0,.22v1.12a.29.29,0,0,1,0,.17.07.07,0,0,1-.1,0l-1.46-.84v1.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "460.15 210.64 448.53 190.36 443.08 193.58 443.08 190.76 440.34 189.17 440.34 195.21 436.92 197.23 439.55 198.75 439.55 212.99 446.05 216.74 446.05 207.64 451.02 210.52 451.02 219.62 457.52 223.37 457.52 209.12 460.15 210.64",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.92,192.92a.62.62,0,0,1-.58-.38s-1.46-3.55-3.81-4.9a2.37,2.37,0,0,0-3.26.34.62.62,0,0,1-.87.11.6.6,0,0,1-.12-.86,3.64,3.64,0,0,1,4.88-.67c2.71,1.57,4.27,5.35,4.33,5.51a.62.62,0,0,1-.34.81A.66.66,0,0,1,452.92,192.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.29,188.89a.62.62,0,0,1-.6-.47,16,16,0,0,0-6.7-7.58c-4.75-2.74-8.26,1.21-8.41,1.38a.63.63,0,0,1-.88.07.62.62,0,0,1-.06-.88s4.31-4.92,10-1.65a16.76,16.76,0,0,1,7.28,8.37.63.63,0,0,1-.46.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.17,190.75a.62.62,0,0,1-.59-.44,14.34,14.34,0,0,0-5.3-6.14,4.73,4.73,0,0,0-5.91.89.63.63,0,0,1-.88.06.62.62,0,0,1-.05-.88,6,6,0,0,1,7.46-1.15,15.13,15.13,0,0,1,5.87,6.86.63.63,0,0,1-.42.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,230.07l13.59,7.84a2.31,2.31,0,0,1,1,1.81v2.11c0,.67-.47.94-1,.61l-13.59-7.85a2.29,2.29,0,0,1-1-1.81v-2.11C430.26,230,430.72,229.73,431.3,230.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.89,241.37l13.59,7.85a2.26,2.26,0,0,1,1,1.81v2.11c0,.67-.46.94-1,.6l-13.59-7.84a2.31,2.31,0,0,1-1-1.81V242C449.85,241.31,450.32,241,450.89,241.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.3,239.12,444.89,247a2.31,2.31,0,0,1,1,1.8v2.12c0,.66-.47.93-1,.6l-13.59-7.84a2.32,2.32,0,0,1-1-1.81v-2.12C430.26,239.06,430.72,238.79,431.3,239.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.89,250.43l13.59,7.84a2.28,2.28,0,0,1,1,1.81v2.11c0,.67-.46.94-1,.61L450.89,255a2.31,2.31,0,0,1-1-1.81V251C449.85,250.36,450.32,250.09,450.89,250.43Z",
    style: {
      fill: "#fafafa"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHome);
export default __webpack_public_path__ + "static/media/addHome.58ea716bf6202e28eaf26cfc37d58f37.svg";
export { ForwardRef as ReactComponent };